export const TRANSLATIONS = {
  app: {
    name: "YDRAY",
  },

  routes: {
    // Common routes
    common: {
      home: "/",
      go_back: "..",
    },
    // Public routes
    public: {
      about: "sobre-nosotros",
      plans: "planes",
      press: "prensa",
      contact: "contacto",
      login: "login",
      register: "registro",
      forget: "recordar-password",
      newsletter_reg: "alta-newsletter",
      newsletter_unreg: "baja-newsletter",
      faq: "preguntas-frecuentes",
      cookies: "politica-cookies",
      privacy: "politica-privacidad",
      legal: "informacion-legal",
      send_files: {
        index: "enviar-archivos",
        big: "grandes",
        free: "gratis",
      },
      share_files: {
        index: "compartir-archivos",
        big: "grandes",
        free: "gratis",
      },
      uploader: "uploader",
    },
    // Private routes
    private: {
      uploads: {
        index: "transferencias",
        detail: "detalle",
      },
      prefs: {
        index: "preferencias",
        plans: {
          index: "planes",
          subscription: "suscripcion",
        },
        billing: "facturacion",
        personal: "usuario",
        security: "seguridad",
        custom: "personalizar",
        contact: "contacto",
      },
    },
  },

  langs: {
    es: "Castellano",
    en: "English",
  },

  button: {
    accept: "Aceptar",
    add: "Añadir",
    change: "Cambiar",
    delete: "Borrar",
    edit: "Editar",
    save: "Guardar",
    update: "Actualizar",
    copy: "Copiar",
    search: "Buscar",
    close: "Cerrar",
    menu: "Menú",
    send: "Enviar",
    upload: "Subir",
    download: "Descargar",
    login: "Iniciar Sesión",
    logout: "Cerrar Sesión",
    more_info: "Más Información",
    share: "Compartir",
    try: "Probar",
    cancel: "Cancelar",
    cancelAll: "Cancelar todos",
    reupload: "Resubir",
    reuploadAll: "Resubir todos",
    contact: "Contactar",
    waiting_list: "Lista de Espera",
    subscription: "Suscribirse",
    actual_plan: "Plan Actual",
    open_link: "Abrir enlace",
    preview: "Previsualización",
    enable: "Activar",
    disable: "Desactivar",
    expire: "Caducar",
    here: "aquí",
    subscribe_plan: "Obtener Plan",
    cancel_plan: "Cancelar Plan",
    resume_plan: "Renovar Plan",
    change_plan: "Cambiar Plan",
    set_default: "Por defecto",
    show_password: "Mostrar Password",
    hide_password: "Ocultar Password",
    create_account_free: "Crear cuenta gratis",
    go_pro: "Hazte PRO!",
  },

  dialog: {
    types: {
      info: "Información",
      warn: "Advertencia",
      error: "Error",
      success: "Éxito",
      share: "Compartir",
      detail: "Detalle",
    },
  },

  placeholder: {
    search: "Buscar...",
    empty: "(campo vacío)",
    empty_list: "Lista vacía",
    empty_table: "No se han encontrado resultados",
    loading: "Cargando...",
    waiting: "Esperando",
    cancelled: "Cancelado",
    uploading: "Subiendo",
    error: "Error",
    select: "Selecciona una opción",
  },

  social_media: {
    mail: "Email",
    gmail: "Gmail",
    youtube: "Youtube",
    twitter: "Twitter",
    facebook: "Facebook",
    whatsapp: "WhatsApp",
    linkedin: "LinkedIn",
    instagram: "Instagram",
    share_ph: "Compartir...",
    share_msg: "Te envío estos archivos por YDRAY",
    links: {
      youtube: "https://www.youtube.com/channel/UCUEyel0jLWYlOxr8HuXUEqA",
      twitter: "https://twitter.com/Ydray_",
      facebook: "https://www.facebook.com/Ydray",
      instagram: "https://www.instagram.com/ydray.com_",
      linkedin: "https://www.linkedin.com/company/ydray",
    },
  },

  subscription: {
    free: "FREE",
    pro: "PRO",
  },

  errors: {
    default: "Ha ocurrido un error, por favor, inténtalo de nuevo más tarde",
    unknown: "Ha ocurrido un error, por favor, inténtalo de nuevo más tarde",
    not_implemented: "Funcionalidad no desarrollada todavía",
    session_expired: "Tu sesión ha caducado, vuelve a iniciar sesión",
    not_yet_active: "Esta transferencia aún no está disponible",
    email_gate_required:
      "Esta transferencia requiere verificación por email para descargarse",
    not_available_func:
      "Funcionalidad no disponible, por favor, inténtalo de nuevo más tarde",
    empty: "El campo {{field}} no puede estar vacío",
    empty_list: "No hay resultados para mostrar en este momento",
    already_registered: "Ya existe un usuario registrado",
    invalid_email: "El correo no es válido",
    field_too_long: "El campo {{field}} es demasiado largo",
    field_too_short: "El campo {{field}} es demasiado corto",
    invalid_email_or_pass: "El correo o la contraseña no son válidos",
    pass_not_equal: "Las contraseñas no coinciden",
    pass_too_long: "La contraseña es demasiado larga",
    pass_too_short: "La contraseña es demasiado corta",
    msg_too_long: "El comentario es demasiado largo",
    title_too_long: "El título es demasiado largo",
    invalid_old_pass: "La contraseña antigua no coincide",
    new_pass_not_equal: "La contraseña nueva no coincide",
    existed_file: "Ya existe un archivo con el mismo nombre",
    file_too_big: "El archivo es demasiado grande",
    max_upload_size:
      "Se ha excedido el tamaño total permitido por subida (máximo {{size}})",
    min_upload_size:
      "Se ha producido un error con el tamaño mínimo permitido por subida (mínimo {{size}})",
    fileType: "El tipo de archivo no está permitido",
    error_db:
      "Ha ocurrido un error de base de datos, por favor inténtalo de nuevo más tarde",
    bbdd: "Ha ocurrido un error de base de datos, por favor inténtalo de nuevo más tarde",
    unauthenticated: "No tienes permisos para subir archivos",
    forbidden: "No tienes permisos para realizar la acción",
    expired: "El enlace de descarga ha expirado",
    unsupported_browser: "Navegador no soportado",
    expired_session: "Tu sesión ha expirado, por favor vuelve a autenticarte",
    password_protected: "El enlace de descarga está protegido por contraseña",
    wrong_pass: "La contraseña no coincide",
    not_confirmed: "El email proporcionado no ha sido confirmado",
    maintenance:
      "El servicio se encuentra en mantenimiento. Por favor, inténtalo de nuevo más tarde",
    incorrect_captcha: "El captcha no es correcto",
    incorrect_email: "El correo no es válido",
    email_does_not_exist: "El email no está registrado en YDRAY",
    missing_message: "El mensaje no es correcto",
    missing_name: "El nombre/empresa no es correcto",
    transfer_not_found: "No se ha encontrado la transferencia",
    conditions_not_accepted: "Las condiciones deben ser aceptadas",
    invalid_url: "🤔 ¡Ups! Parece que aquí no hay nada...",
    error_form: "Por favor, resuelve los problemas del formulario",
    min_file_per_upload_one:
      "El número mínimo de archivos por subida es de {{count}} archivo",
    min_file_per_upload_other:
      "El número mínimo de archivos por subida es de {{count}} archivos",
    max_file_per_upload_one:
      "El número máximo de archivos por subida es de {{count}} archivo",
    max_file_per_upload_other:
      "El número máximo de archivos por subida es de {{count}} archivos",
    delete_file:
      "Ha ocurrido un error al borrar el archivo, por favor inténtalo de nuevo más tarde",
    server_maintenance: "El servidor se encuentra en mantenimiento",
    search_chars:
      "Introduce al menos {{count}} caracteres para buscar transferencias",
    invalid_opt: "La opción seleccionada no está registrada",
    expired_date: "Caducada",
    exp_transfer_date: "Transferencia caducada",
    files:
      "Ha ocurrido un error de cookies, por favor inténtalo de nuevo más tarde",
    adblock_detected: "AdBlock detectado",
    iab_cookie_not_detected: "La cadena de TC no se detecta",
    iab_cookie_expired:
      "La última actualización de la cadena de TC fue hace más de 13 meses",
    not_correct_user:
      "La sesión del usuario no coincide con el de la suscripción",
    user_is_pro: "El usuario ya tiene una suscripción PRO",
    not_logged_user: "La sesión del usuario no es válida",
    not_found_subscription: "No se ha encontrado la suscripción",
    not_id_send:
      "No se ha enviado el identificador de la suscripción del usuario",
    not_confirmed_subscription:
      "No se ha podido confirmar el estado de la suscripción",
    not_cancelled_subscription:
      "No se ha podido cancelar la suscripción del usuario",
    error_subscription: "Ha ocurrido un error al realizar la suscripción",
    cancel_subcription_process:
      "Suscripción no realizada. Se ha cerrado el popup antes de tiempo",
    payment_error: "Ha ocurrido un error al realizar el pago",
    unexpected: "Ha ocurrido un error, por favor, inténtalo de nuevo más tarde",
    date_not_valid: "La fecha no es correcta",
    file_error: "Ha ocurrido un error al subir el archivo",
    create_thumb: "Ha ocurrido un error al crear la miniatura",
    error_rename: "Ha ocurrido un error al renombrar el archivo",
    mfa_not_enabled: "La doble autenticación no se ha activado",
    mfa_already_enabled: "La doble autenticación ya está activada",
    mfa_already_disabled: "La doble autenticación ya está desactivada",
    mfa_secret_not_stored: "El secreto no se ha encontrado",
    mfa_missing_otp: "El código no se ha enviado",
    mfa_not_updated: "La doble autenticación no se ha activado",
    mfa_invalid_otp: "El código es inválido o ha expirado",
    mfa_verify: "La protección 2FA está activa en tu cuenta",
    error_recaptcha:
      "Ha ocurrido un error al comprobar la protección reCAPTCHA",
    plan_not_active: "No existe un plan activo",
    plan_schedule_active: "Existe un cambio de plan activo",
    plan_already_changed: "El plan ya ha sido cambiado previamente",
    plan_already_canceled: "El plan ya ha sido cancelado previamente",
    change_inactive_plan:
      "No se puede cambiar un plan inactivo, por favor, renueva tu plan primero",
    invalid_eu_vat: "El número de identificación fiscal no es válido",
    forbidden_word: "El subdominio está en un listado de palabras no válidas",
    username_length:
      "La longitud del subdominio debe ser entre 6 y 26 caracteres",
    username_invalid_format: "El formato del subdominio no es válido",
    username_already_exists:
      "El subdominio ya existe, por favor, utiliza otro distinto",
    incorrect_promotion_code: "El código promocional no es válido",
    network_error:
      "Ha ocurrido un error de red, por favor, inténtalo de nuevo más tarde",
  },

  message: {
    default: "La operación se ha realizado correctamente",
    success: "La operación se ha realizado correctamente 👍",
    send_mail: "Se ha enviado un email a tu cuenta ✉️",
    need_help: "¿Necesitas ayuda para continuar?",
    askConfirmation:
      "Si sales perderás los datos introducidos, ¿deseas continuar?",
    askConfirmationPayment:
      "Si sales perderás los datos del preceso de pago, ¿deseas continuar?",
    language: "¡El idioma ha cambiado correctamente! 🌎",
    clipboard: "¡Copiado al portapapeles! 📋",
    undo: "Se han descartado los cambios correctamente 👍",
    edit: "Se han guardado los datos correctamente 👍",
    download: "Se ha descargado el archivo correctamente 👍",
    upload: "Se ha subido el archivo correctamente 👍",
    delete: "Se han borrado los datos correctamente 👍",
    delete_transfer: "Se ha borrado la transferencia correctamente 👍",
    delete_file_one: "Se ha borrado el archivo correctamente 👍",
    delete_file_other: "Se han borrado los archivos correctamente 👍",
    delete_from_server: "El archivo debe borrarse en servidor",
    delete_from_store: "El archivo debe borrarse en almacenamiento",
    retry_file_one: "Se ha añadido el archivo a la cola correctamente 👍",
    retry_file_other: "Se han añadido los archivos a la cola correctamente 👍",
    set_background: "Se ha añadido el fondo a la trasferencia correctamente 👍",
    clear_background:
      "Se ha quitado el fondo de la trasferencia correctamente 👍",
    have_not_uploaded_files: "Tienes archivos sin compartir",
    reload_uploading_files:
      "Hay una subida activa, ¿quieres abandonar la página?",
    mail_check: "Te hemos enviado un email para confirmar el cambio",
    create_user_ok:
      "Se ha enviado un correo a tu email, revisa la carpeta de SPAM",
    not_found: "No existen resultados para la búsqueda solicitada",
    prevent_reload:
      "Si continúas con la recarga de la página, los cambios se perderán, ¿deseas continuar?",
    unsaved_changes: "Los cambios realizados se perderán, ¿deseas continuar?",
    iab_cookie_expired:
      "La última actualización de la cadena de TC fue hace más de 13 meses",
    iab_cookie_not_expired:
      "La última actualización de la cadena de TC fue hace menos de 13 meses",
    new_ad_slot: "Nuevo slot de anuncio",
    adblock_detected: "AdBlock detectado... 😭",
    adblock_not_detected: "AdBlock no detectado... 😍",
    please_ads:
      "YDRAY necesita los anuncios para mantenerse, por favor desactiva tu bloqueador",
    please_ads_short: "Por favor, desactiva tu bloqueador de anuncios",
    user_changed_to_pro: "La suscripción se ha realizado correctamente",
    not_expirable_transfer: "Transferencia no caducable",
    mfa_disabled: "Se ha desactivado la protección 2FA correctamente 👍",
    mfa_enabled: "Se ha activado la protección 2FA correctamente 👍",
    update_subdomain: "Se ha actualizado el subdominio correctamente 👍",
    remove_subdomain: "Se ha borrado el subdominio correctamente 👍",
    log_in: "Bienvenid@ a tu cuenta 😍",
    log_out: "La sesión se ha cerrado correctamente 👍",
    another_attempt: "Se realizará otro intento...",
    max_attempt: "Se ha llegado al máximo de intentos...",
    registered_request: "Tu petición ha sido recibida correctamente 👍",
    change_password: "Se ha cambiado la contraseña correctamente 👍",
  },

  validators: {
    number: "El campo tiene que ser un valor numérico",
    integer: "El campo tiene que ser un valor entero",
    positive: "El campo tiene que ser un valor positivo",
    negative: "El campo tiene que ser un valor negativo",
    phone: "El campo no es un número de teléfono válido",
    notEmpty: "El campo no puede estar vacío",
    email: "El campo no es una dirección de correo válida",
    compareFields: "El valor del campo no concuerda con el anterior",
    lessThan: "El campo no puede ser menor que {{value}}",
    moreThan: "El campo no puede ser mayor que {{value}}",
    minLength: "El campo no puede ser menor que {{value}} caracteres",
    maxLength: "El campo no puede ser mayor que {{value}} caracteres",
    checkTrue: "El campo tiene que ser marcado",
    no_whitespaces: "El campo no puede contener espacios en blanco",
    max_size_file: "El archivo no puede ser mayor de {{size}}",
    max_num_files_one: "El campo solo admite un archivo",
    max_num_files_other: "El campo solo admite {{count}} archivos",
    file_extension_one: "El archivo solo puede tener la extensión: {{list}}",
    file_extension_other:
      "El archivo solo puede tener las extensiones: {{list}}",
    min_resolutions: "La imagen debe ser mayor de {{width}}x{{height}} píxeles",
    max_resolutions: "La imagen debe ser menor de {{width}}x{{height}} píxeles",
    invalid_url: "El campo no es una dirección válida",
    invalid_subdomain: "El campo no es un subdominio válido",
    invalid_recaptcha: "El valor de reCAPTCHA no es válido",
    expired_recaptcha: "El valor de reCAPTCHA ha expirado",
    invalid_vat: "El Nº Id. Fiscal no es válido",
    invalid_password: "La contraseña no es válida",
    not_same_password: "La contraseña no puede ser la misma que la anterior",
  },

  maintenance: {
    title: "Estamos de mantenimiento",
    message:
      "El servidor se encuentra en mantenimiento. Por favor, vuelve en unos minutos para compartir y enviar tus archivos.",
  },

  block_upload: {
    title: "YDRAY ya está abierto en otra ventana",
    message:
      "Sigue enviando y compartiendo archivos con YDRAY en la otra ventana",
  },

  error_upload: {
    title: "Ha ocurrido un error en YDRAY",
    message: "Ha ocurrido un error, por favor, inténtalo de nuevo más tarde",
  },

  downloader_expired: {
    title: "Tu enlace ha expirado",
    message: "El enlace de descarga ha expirado",
  },

  banner: {
    pro_plan: {
      message:
        "Recuerda que puedes suscribirte al plan YDRAY PRO para tener más capacidad de almacenamiento y transferencias ilimitadas.",
      short_message:
        "Suscribete al plan YDRAY PRO para obtener más funcionalidades",
      stats_message:
        "Suscribete al plan YDRAY PRO y obtiene más funcionalidades",
    },
  },

  tooltip: {
    feature_pro_message:
      "Suscríbete a la cuenta Pro para tener acceso a esta sección",
  },

  logo: {
    title: "Logo de YDRAY",
    alt: "Logo de YDRAY",
    stripe: {
      title: "Logo de Stripe",
      alt: "Logo de Stripe",
    },
    efficy: {
      title: "Logo de Efficy",
      alt: "Logo de Efficy",
    },
  },

  wordmark: {
    title: "YDRAY",
    alt: "YDRAY",
  },

  header_menu: {
    about_us: "Sobre Nosotros",
    plans: "Planes",
    account: "Cuenta",
    uploads: "Transferencias",
  },

  footer_menu: {
    about_us: "Sobre Nosotros",
    plans: "Planes",
    account: "Cuenta",
    login: "Iniciar Sesión",
    uploads: "Transferencias",
    preferences: "Preferencias",
    upload_files: "Envía tus archivos",
  },

  login_dialog: {
    title: "Inicia Sesión",
    subtitle: "",
    form: {
      email: "Email",
      emailph: "Introduce tu email",
      loginpass: "Contraseña",
      loginpassph: "Introduce tu contraseña",
      create_account: "¿No tienes una cuenta?",
      logIn: "Regístrate",
      forget_password: "¿Has olvidado la contraseña?",
      remind_me: "Recordar",
    },
    button: {
      login: "Iniciar Sesión",
    },
  },

  register_dialog: {
    title: "Crear Cuenta",
    subtitle: "Después podrás elegir el plan que prefieras",
    form: {
      username: "Nombre de Usuario",
      email: "Email",
      emailph: "Introduce tu email",
      pass1: "Contraseña",
      pass1ph: "Introduce tu contraseña",
      pass2: "Repite Contraseña",
      pass2ph: "Repite tu contraseña",
      promotion_code: {
        label: "Código promoción",
        placeholder: "Introduce tu código",
      },
      consent_privacy: {
        template:
          "<text>He leído, entiendo y acepto la <privacy_link>política de privacidad</privacy_link>.</text>",
        text: "Política de Privacidad",
      },
      consent_marketing: {
        template:
          "<text>Consiento el tratamiento de mis datos para el envío de comunicaciones comerciales por parte de YDRAY</text>",
        text: "Comunicación Comercial",
      },
      login_account: "¿Ya tienes una cuenta?",
      logIn: "Inicia sesión",
      forget_password: "¿Has olvidado la contraseña?",
      remind_me: "Recordar",
    },
    button: {
      create: "Crear Cuenta",
    },
  },

  forget_password_dialog: {
    title: "¿Has olviado la contraseña?",
    subtitle: "¡No te preocupes, te ayudaremos!",
    form: {
      email: "Email",
      emailph: "Introduce tu email",
      login_account: "¿Ya tienes una cuenta?",
      logIn: "Inicia sesión",
      create_account: "¿No tienes una cuenta?",
      register: "Regístrate",
    },
    button: {
      remind_me: "Recordar",
    },
  },

  reg_newsletter_dialog: {
    title: "Newsletter",
    subtitle: "¡Apúntate a nuestra newsletter!",
    form: {
      email1: "Email",
      email2: "Repite el email",
      consent_privacy: {
        template:
          "<text>He leído, entiendo y acepto la <privacy_link>política de privacidad</privacy_link>.</text>",
        text: "Política de Privacidad",
      },
      consent_marketing: {
        template:
          "<text>Consiento el tratamiento de mis datos para el envío de comunicaciones comerciales por parte de YDRAY</text>",
        text: "Comunicación Comercial",
      },
    },
  },

  unreg_newsletter_dialog: {
    title: "Newsletter",
    subtitle:
      "Para darte de baja de nuestra newsletter, por favor introduce el correo con el que te apuntaste",
    form: {
      email: "Email",
    },
  },

  consent_dialog: {
    title: "Te damos la bienvenida a ydray.com",
    subtitle:
      "ydray.com solicita tu consentimiento para usar tus datos personales con estos objetivos:",
    ad: "Anuncios y contenido personalizados, medición de anuncios y del contenido, información sobre el público y desarrollo de productos",
    storage: "Almacenar o acceder a información en un dispositivo",
    moreinfo: "Más información",
    moreinfo_p1:
      "Tus datos personales se tratarán y la información de tu dispositivo (cookies, identificadores únicos y otros datos del dispositivo) podrá ser almacenada, consultada y compartida con proveedores externos o utilizada específicamente pos este sitio web o aplicación.",
    moreinfo_p2:
      "Es posible que algunos proveedores traten tus datos personales en virtud de un interés legítimo, algo a lo que puedes oponerte gestionando tus opciones a continuación. Busca un enlace al final de esta página o en nuestra política de privacidad para revocar el consentimiento.",
    button: {
      management_ops: "Gestionar Opciones",
      consent: "Consentir",
    },
  },

  billing_dialog: {
    title: "Suscripción - {{subscription}}",
    description: "Suscríbete al plan {{subscription}}",
    header: {
      title: "Plan {{subscription}}",
      subtitle: "Por favor, comprueba tus datos antes de continuar",
    },
    body: {
      form: {
        account: {
          title: "Datos Usuario",
          name: "Nombre Completo",
          email: "Email",
          phone: "Teléfono",
        },
        billing: {
          title: "Datos de Facturacíón",
          line1: "Direccíón Línea 1",
          line2: "Dirección Línea 2",
          postalCode: "Código Postal",
          city: "Ciudad",
          state: "Estado/Provincia",
          country: "País",
          isCompany: "Soy una empresa",
          companyName: "Nombre Empresa",
          vat: {
            label: "Nº Ident. Fiscal",
            tooltip: {
              title: "¿Qué es el Número de Identificación Fiscal?",
              rules: {
                1: "Solo se validará para países de la Unión Europea",
                2: "Debe empezar con el código del país europeo",
                3: "El país de la dirección y el código del país deben ser el mismo",
                4: "El formato es único por cada país",
              },
              link: "<container>Si necesitas ayuda, haz click <help_link>{{here}}</help_link>.</container>",
            },
          },
        },
      },
    },
    footer: {},
    confirm: {
      header: {
        title: "Confirmación",
        subtitle: "Es necesaria tu confirmación",
      },
      body: {
        template:
          "<container><p>Por favor, verifica que la información introducida sea correcta y esté actualizada. Estos datos son necesarios para gestionar los cobros y generar tus facturas de forma adecuada.</p><p>Si detectas algún error, te recomendamos corregirlo ahora para asegurarte de que todo esté en orden.</p><p>¿Deseas continuar?</p></container>",
      },
    },
  },

  share_transfer_dialog: {
    header: {
      title: "Compartir",
      subtitle: "Comparte tu transferencia",
    },
    body: {},
    footer: {},
  },

  file_download_dialog: {
    title: "Información de las descargas del archivo",
    description: "Información de las descargas del archivo",
    header: {
      title: "Descargas",
      subtitle: "Resumen de actividad del archivo",
    },
    body: {
      table: {
        columns: {
          date: "Fecha",
          country: "País",
          region: "Región",
          device: "Dispositivo",
          browser: "Navegador",
          zone: "Zona",
          summary: "Resumen",
        },
        rows: {
          device: {
            phone: "Teléfono",
            tablet: "Tablet",
            pc: "Ordenador",
          },
          browser: {
            edge: "Microsoft Edge",
            firefox: "Mozilla Firefox",
            chrome: "Google Chrome",
            safari: "Safari Browser",
          },
        },
      },
    },
    footer: {},
  },

  preview_background_dialog: {
    header: {
      title: "Fondo",
      subtitle: "Fondo personalizado de la transferecia",
    },
    body: {},
    footer: {},
  },

  transfer_password_dialog: {
    header: {
      title: "Contraseña",
      subtitle: {
        new: "Añade una contraseña a la transferencia",
        modify: "Modifica la contraseña de la transferencia",
      },
      help: {
        tooltip: {
          title: "Consejo",
          rules: {
            1: "Al menos una letra mayúscula",
            2: "Al menos una letra minúscula",
            3: "Al menos un número",
            4: "Al menos un carácter especial",
            5: "Sin espacios",
            6: "La contraseña debe ser entre 8 y 16 caracteres",
          },
          delete: "Deja en blanco los campos si quieres borrar la contraseña",
        },
      },
    },
    body: {
      form: {
        password1: {
          label: "Nueva contraseña",
          placeholder: "Nueva contraseña",
        },
        password2: {
          label: "Repite contraseña",
          placeholder: "Repite contraseña",
        },
      },
    },
    footer: {},
    messages: {
      new_password: "La contraseña se ha añadido correctamente 👍",
      edit_password: "La contraseña se ha modificado correctamente 👍",
      remove_password: "La contraseña se ha eliminado correctamente 👍",
    },
  },

  transfer_customlink_dialog: {
    header: {
      title: "Link Personalizado",
      subtitle: "Edita el link personalizado a tu transferencia",
    },
    body: {
      form: {
        example: {
          label: "Tu enlace persionalizado",
        },
        custom_link: {
          label: "Enlace Personalizado",
          placeholder: "<enlace personalizado>",
          tooltip: {
            title: "Reglas de validación del enlace",
            rules: {
              1: "Puede contener letras y números",
              2: "Solo letras minúsculas",
              3: "No puede empezar o terminar por guión",
              4: "No puede contener dos guiones seguidos",
              5: "La longitud será entre 6 y 26 caracteres",
              6: "Algunas palabras no están permitidas",
            },
            delete: "Deja en blanco el campo si quieres borrar tu enlace",
          },
        },
      },
    },
    footer: {},
  },

  change_password_dialog: {
    header: {
      title: "Cambiar Contraseña",
      subtitle: "Aqui podrás cambiar tu contraseña",
    },
    body: {
      form: {
        oldpass: {
          title: "Contraseña Anterior",
          label: "Contraseña",
          placeholder: "Introduce tu contraseña",
        },
        pass1: {
          title: "Contraseña Nueva",
          label: "Nueva Contraseña",
          placeholder: "Introduce tu nueva contraseña",
          tooltip: {
            title: "Consejo",
            rules: {
              1: "Al menos una letra mayúscula",
              2: "Al menos una letra minúscula",
              3: "Al menos un número",
              5: "Sin espacios",
              6: "La contraseña debe ser entre 8 y 16 caracteres",
            },
          },
        },
        pass2: {
          title: "",
          label: "Repite Contraseña",
          placeholder: "Repite tu nueva contraseña",
        },
      },
    },
  },

  enable_mfa_dialog: {
    header: {
      title: "Activa 2FA",
      subtitle: "Escanea el QR e introduce el código",
    },
    body: {
      text: "<text>Puedes acceder a tu App, haciendo click <otp_link>{{here}}</otp_link>.</text>",
      form: {
        code: "Tu código",
      },
    },
    footer: {},
  },

  disable_mfa_dialog: {
    header: {
      title: "Desactiva 2FA",
      subtitle: "Introduce el código",
    },
    body: {
      form: {
        code: "Tu código",
      },
    },
    footer: {
      help: "<text>¿Tienes algún problema? <contact_link>{{contact}}</contact_link></text>",
      contact: "Contactar",
    },
  },

  login_mfa_dialog: {
    header: {
      title: "Autenticación 2FA",
      subtitle: "Introduce el código",
    },
    body: {
      form: {
        code: "Tu código",
      },
    },
    footer: {
      help: "<text>¿Tienes algún problema? <contact_link>{{contact}}</contact_link></text>",
      contact: "Contactar",
    },
  },

  check_payment_sub_dialog: {
    header: {
      payment: {
        title: "Comprobar Pago",
        subtitle_checking: "Comprobando el pago",
        subtitle_success: "Pago comprobado",
        subtitle_error: "Error en el pago",
      },
      status: {
        title: "Modificar Cuenta",
        subtitle_checking: "Modificando tu cuenta",
        subtitle_success: "Cuenta mejorada",
        subtitle_error: "Error modificando la cuenta",
      },
    },
    body: {
      payment: {
        checking: "Comprobando Pago",
        success: "El pago ha sido comprobado correctamente 👍",
        error: "Ha ocurrido un error con el pago ❌",
      },
      status: {
        checking: "Comprobando Cuenta",
        success: "Los cambios se han realizado correctamente 👍",
        error: "Ha ocurrido un error al comprobar tu cuenta ❌",
      },
    },
    footer: {
      help: "<text>¿Tienes algún problema? <contact_link>{{contact}}</contact_link></text>",
      contact: "Contactar",
    },
  },

  cancel_plan_dialog: {
    header: {
      title: "Cancelar Suscripción",
      subtitle: "Vas a cancelar tu suscripción YDRAY",
    },
    body: {
      template:
        "<container><p>Si decides cancelar tu suscripción <strong>YDRAY PRO</strong>, podrás seguir utilizando las funcionalidades avanzadas de la suscripción hasta el <strong>{{end_date}}</strong>.</p><p>A partir de la fecha de cancelación, tu suscripción terminará automáticamente y tu cuenta volverá a ser <strong>YDRAY FREE</strong>.</p><p>Este cambio en tu suscripción puede revertirse antes de la fecha de cancelación en cualquier momento.</p><p>¿Deseas cancelar tu suscripción?</p></container>",
    },
    confirm: {
      header: {
        title: "Confirmación",
        subtitle: "Es necesaria tu confirmación",
      },
      body: {
        template:
          "<container><p>Existe un cambio de plan programado en tu suscripción para el día <strong>{{end_date}}</strong>.</p><p>Si cancelas tu plan actual, también se cancelará el cambio al nuevo plan.</p><p>¿Deseas cancelar la subscripción?</p></container>",
      },
    },
  },

  resume_plan_dialog: {
    header: {
      title: "Renovar Suscripción",
      subtitle: "Vas a renovar tu suscripción YDRAY",
    },
    body: {
      template:
        "<container><p>Si decides renovar tu suscripción <strong>YDRAY PRO</strong>, podrás seguir utilizando las funcionalidades avanzadas de la suscripción igual que estás haciendo ahora.</p><p>Al renovar tu suscripción, tu próxima fecha de facturación será el día <strong>{{end_date}}</strong>.</p><p>¿Deseas renovar tu suscripción?</p></container>",
    },
  },

  change_plan_dialog: {
    header: {
      title: "Cambiar Suscripción",
      subtitle: "Vas a cambiar tu suscripción YDRAY",
    },
    body: {
      template: `
          <container>
            <p>Si cambias tu plan actual <strong>{{old_plan}}</strong> por <strong>{{new_plan}}</strong>, podrás continuar con tu suscripción actual hasta <strong>{{end_date}}</strong>.</p>
            <p>Después de esa fecha, se te facturará el nuevo plan elegido.</p>
            <p>¿Deseas cambiar tu plan?</p>
          </container>
        `,
    },
  },

  subscription_page: {
    title: "Suscripción",
    description: "Suscríbete al plan PRO de YDRAY",
  },

  cancel_subscription_page: {
    title: "Cancelar suscripción",
    description: "Cancelación de plan de suscripción",
    messages: {
      empty: "No existen datos de la suscripción",
    },
  },

  dropdown: {
    placeholder: "Seleccione...",
    order: "Ordenar por",
    day_one: "día",
    day_other: "días",
    dayWithCount_one: "{{count}} día",
    dayWithCount_other: "{{count}} días",
    never: "Nunca",
  },

  uploader: {
    add_files_content: {
      title: "Añade tus archivos a compartir",
      subtitle:
        "Pulsa añadir o suelta aquí tus archivos para que empiece la carga",
      list_items: `
        <li class="list-item">
          <span class="item-icon smaller icon-check"></span>
          <span class="item-text smaller">Compartir y enviar archivos grandes hasta 10 GB gratis</span>
        </li>
        <li class="list-item">
          <span class="item-icon smaller icon-check"></span>
          <span class="item-text smaller">Compartir y enviar archivos grandes sin necesidad de registro</span>
        </li>
        <li class="list-item">
          <span class="item-icon smaller icon-check"></span>
          <span class="item-text smaller">Máxima privacidad al compartir y enviar archivos</span>
        </li>
      `,
      privacy_consent: `
        Para enviar y compartir tus archivos, rogamos aceptes nuestra <a class="link" href='/es/politica-privacidad/' title="política de privacidad">política de privacidad</a>,
        <a class="link" href="/es/informacion-legal/" title="condiciones del servicio">condiciones del servicio</a> y <a class="link" href="/es/politica-cookies" title="política de cookies">política de cookies</a>.
        Usamos cookies con fines funcionales y estadísticos, y cookies de terceros con fines publicitarios.
      `,
    },
    share_content: {
      title: "¡Listo para compartir!",
      button: {
        generate: "Generar enlace",
        copy: "Copiar enlace",
        share: "Compartir",
        new: "Nueva subida",
      },
    },
    upload_files_content: {
      add_files: "Añade archivos",
      file_one: "archivo",
      file_other: "archivos",
      fileWithCount_one: "{{count}} archivo",
      fileWithCount_other: "{{count}} archivos",
      uploading_file_one: "Subiendo archivo",
      uploading_file_other: "Subiendo archivos",
      uploading_fileWithCount_one: "Subiendo {{count}} archivo",
      uploading_fileWithCount_other: "Subiendo {{count}} archivos",
      uploaded_file_one: "Archivo subido",
      uploaded_file_other: "Archivo subidos",
      uploaded_fileWithCount_one: "{{count}} archivo subido",
      uploaded_fileWithCount_other: "{{count}} archivos subidos",
      title: "Título",
      comment: "Comentario",
      deleteIn: "Eliminar en",
      password: "Contraseña",
      background: "Fondo",
    },
    upload_detail_content: {
      add_files: "Añade archivos",
      back: "Volver",
      title_error_one: "error",
      title_error_other: "errores",
      title_errorWithCount_one: "{{count}} error",
      title_errorWithCount_other: "{{count}} errores",
      title_uploads_one: "archivo",
      title_uploads_other: "archivos",
      title_uploadsWithCount_one: "{{count}} archivo",
      title_uploadsWithCount_other: "{{count}} archivos",
    },
    pro_ad: {
      title: "Versión PRO",
      subtitle:
        "Recuerda que puedes suscribirte para tener más capacidad de almacenamiento y transferencias ilimitadas",
    },
  },

  downloader: {
    title: "Tu descarga está lista",
    subtitle: "Antes introduce tu contraseña",
    file_one: "archivo",
    file_other: "archivos",
    fileWithCount_one: "{{count}} archivo",
    fileWithCount_other: "{{count}} archivos",
    list: {
      file_one: "archivo",
      file_other: "archivos",
      fileWithCount_one: "{{count}} archivo",
      fileWithCount_other: "{{count}} archivos",
      size: "Tamaño: {{size}}",
      expires: "Caduca: {{date}}",
      noExpiry: "Sin caducidad",
      downloadAll: "Descargar todo",
    },
    zip_error: {
      busy: "Ahora mismo todas las descargas ZIP están ocupadas. Inténtalo de nuevo en unos minutos o descarga los archivos uno a uno.",
      expired: "El enlace de descarga ZIP ha caducado. Pulsa de nuevo «Descargar todo» para reintentar.",
      unavailable: "La descarga ZIP no está disponible. Puedes descargar los archivos uno a uno.",
    },
    form: {
      password: "Contraseña",
    },
    not_yet_active: {
      title: "Esta transferencia aún no está disponible",
      message:
        "El remitente la ha programado para una fecha futura. La descarga se desbloqueará automáticamente al llegar el contador a 0.",
      countdown_aria: "Tiempo restante hasta la disponibilidad",
      countdown_summary_days_one: "Falta {{count}} día",
      countdown_summary_days_other: "Faltan {{count}} días",
      countdown_summary_hours_one: "Falta {{count}} hora",
      countdown_summary_hours_other: "Faltan {{count}} horas",
      countdown_summary_minutes_one: "Falta {{count}} minuto",
      countdown_summary_minutes_other: "Faltan {{count}} minutos",
      countdown_summary_seconds: "Disponible en menos de un minuto",
      unit_days: "Días",
      unit_hours: "Horas",
      unit_minutes: "Min",
      unit_seconds: "Seg",
      available_from_label: "Disponible desde",
      timezone_label: "Zona horaria",
      checking_title: "Comprobando disponibilidad…",
      checking_message:
        "Estamos verificando si la transferencia ya está disponible.",
      checking_status_aria: "Comprobando disponibilidad",
    },
    email_gate: {
      title: "Transferencia protegida",
      subtitle:
        "El remitente ha limitado esta transferencia a destinatarios autorizados. Introduce tu email para recibir un código de acceso.",
      email_label: "Tu email",
      email_placeholder: "tu.email@ejemplo.com",
      // Did-you-mean (typos comunes en dominios populares).
      suggestion_label: "¿Quisiste decir {{suggested}}?",
      suggestion_aria_long:
        "¿Quisiste decir {{suggested}} en lugar de {{current}}?",
      suggestion_apply: "Aplicar",
      suggestion_dismiss_aria: "Mantener email original",
      send_button: "Enviar código",
      otp_title: "Introduce tu código",
      otp_subtitle:
        "Te hemos enviado un código de 6 dígitos a {{email}}.",
      otp_info:
        "El código caduca pronto. Revisa también tu carpeta de spam.",
      otp_label: "Código de verificación",
      verify_button: "Verificar",
      resend_available: "Reenviar código",
      resend_wait: "Reenviar en {{seconds}}s",
      back_to_email: "← Cambiar email",
      errors: {
        captcha:
          "Error de verificación. Recarga la página e inténtalo de nuevo.",
        invalid_email: "Email con formato incorrecto",
        invalid_params: "Datos incorrectos. Recarga la página e inténtalo.",
        invalid_otp: "Código incorrecto",
        invalid_otp_remaining_one:
          "Código incorrecto. Te queda {{count}} intento.",
        invalid_otp_remaining_other:
          "Código incorrecto. Te quedan {{count}} intentos.",
        invalid_otp_no_attempts:
          "Este código ya no es válido o está caducado.",
        transfer_expired: "Enlace no válido o caducado",
        network: "Sin conexión",
        method_not_allowed: "Método no permitido. Recarga la página.",
        generic: "Inténtalo de nuevo más tarde.",
      },
    },
  },

  preferences: {
    title: "Preferencias",
    description: "Página donde cambiar tus preferencias en tu cuenta de ydray",
    subtitle: {
      username: "Hola, {{username}}",
      billing: "Facturación",
      account: "Cuenta",
    },
    items: {
      plans: {
        title: "Planes",
        subtitle: "Eres {{subscription}}",
      },
      billing: {
        title: "Facturación",
        subtitle: "Estado, documentos",
      },
      personal: {
        title: "Datos personales",
        subtitle: "Nombre, dirección y empresa",
      },
      security: {
        title: "Seguridad",
        subtitle: "Cambiar contraseña, añadir 2FA",
      },
      customize: {
        title: "Personalizar",
        subtitle: "Enlace personalizado, fondo transferencia",
      },
      contact: {
        title: "Contacto",
        subtitle: "¿En qué podemos ayudarte?",
      },
      logout: {
        title: "Cerrar Sesión",
      },
    },
    confirm: {
      header: {
        title: "Confirmación",
        subtitle: "Es necesaria tu confirmación",
      },
      body: {
        template:
          "<container><p>Si cierras la sesión, tus archivos pendientes por subir se borrarán permanentemente de los servidores de YDRAY.</p><p>¿Deseas continuar?</p></container>",
      },
    },
  },

  plans: {
    title: "Planes",
    description: "Página donde puedes cambiar tu plan YDRAY",
    details: {
      title: "Detalle Suscripción",
      actual_plan: "Plan actual:",
      new_plan: "Nuevo plan:",
      end_date: "Fecha cancelación:",
      renewal_date: "Fecha renovación:",
      tooltip: {
        actual_plan: "Tu plan activo es <strong>{{plan}}</strong>",
        new_plan:
          "A partir del día <strong>{{date}}</strong>, tu próximo plan será <strong>{{plan}}</strong>",
        end_date:
          "Tu suscripción se cancelará automáticamente el día <strong>{{date}}</strong>",
        renewal_date:
          "Tu suscripción se renovará automáticamente el día <strong>{{date}}</strong>",
      },
    },
    unreg: {
      title: "SIN REGISTRO",
      price: {
        taxes: "+ Imp.",
        title: "Sin Coste para siempre",
        template:
          "<container><integer>{{integer}}</integer><currency>{{currency}}</currency><taxes>{{taxes}}</taxes></container>",
      },
      features: {
        1: "Totalmente gratuito",
        2: "Sin necesidad de registro",
        3: "Transferencias de hasta 10Gb",
        4: "Comparte hasta 50 archivos a la vez",
        5: "Archivos disponibles durante 7 días",
      },
    },
    free: {
      title: "YDRAY FREE",
      price: {
        taxes: "+ Imp.",
        title: "Sin Coste para siempre",
        template:
          "<container><integer>{{integer}}</integer><currency>{{currency}}</currency><taxes>{{taxes}}</taxes></container>",
      },
      features: {
        1: "Totalmente gratuito",
        2: "Gestiona tus transferencias",
        3: "Transferencias de hasta 10Gb",
        4: "Comparte hasta 100 archivos a la vez",
        5: "Elige la caducidad de tus transferecias",
        6: "Estadísticas de descargas",
        7: "Protección de transferencias con contraseña",
        8: "Soporte avanzado",
      },
    },
    pro: {
      title: "YDRAY PRO",
      price: {
        taxes: "+ Imp.",
        title: "{{integer}}{{decimal}}{{fraction}}{{currency}}/mes + Impuestos",
        template:
          "<container><integer>{{integer}}</integer><currency>{{currency}}</currency><taxes>{{taxes}}</taxes></container>",
      },
      features: {
        1: "Transferencias ilimitadas",
        2: "Edita tus transferencias",
        3: "Transferecias de hasta 1TB",
        4: "Comparte hasta 300 archivos por transferencias",
        5: "Elige sin límite la caducidad de tus transferencias",
        6: "Subdominio personalizado",
        7: "Fondos personalizados",
        8: "Enlaces personalizados",
        9: "Genera QR con tus enlaces",
        10: "Estadísticas completas de tus transferencias",
        11: "Sin publicidad (ni para ti ni para quien descargan tus archivos)",
        12: "Soporte prioritario",
      },
      month: {
        title: "YDRAY PRO / MENSUAL",
        price: {
          taxes: "+ Imp.",
          title:
            "{{integer}}{{decimal}}{{fraction}}{{currency}}/mes + Impuestos",
          template:
            "<container><integer>{{integer}}</integer><currency>{{currency}}</currency><taxes>{{taxes}}</taxes></container>",
        },
        features: {
          1: "Facturación MENSUAL",
          2: "Transferencias ilimitadas",
          3: "Edita tus transferencias",
          4: "Transferecias de hasta 1TB",
          5: "Comparte hasta 300 archivos por transferencias",
          6: "Elige sin límite la caducidad de tus transferencias",
          7: "Subdominio personalizado",
          8: "Fondos personalizados",
          9: "Enlaces personalizados",
          10: "Genera QR con tus enlaces",
          11: "Estadísticas completas de tus transferencias",
          12: "Sin publicidad (ni para ti ni para quien descargan tus archivos)",
          13: "Soporte prioritario",
        },
      },
      year: {
        title: "YDRAY PRO / ANUAL",
        price: {
          taxes: "+ Imp.",
          title:
            "{{integer}}{{decimal}}{{fraction}}{{currency}}/año + Impuestos",
          template:
            "<container><integer>{{integer}}</integer><currency>{{currency}}</currency><taxes>{{taxes}}</taxes></container>",
        },
        features: {
          1: "Facturación ANUAL (20% Descuento)",
          2: "Transferencias ilimitadas",
          3: "Edita tus transferencias",
          4: "Transferecias de hasta 1TB",
          5: "Comparte hasta 300 archivos por transferencias",
          6: "Elige sin límite la caducidad de tus transferencias",
          7: "Subdominio personalizado",
          8: "Fondos personalizados",
          9: "Enlaces personalizados",
          10: "Genera QR con tus enlaces",
          11: "Estadísticas completas de tus transferencias",
          12: "Sin publicidad (ni para ti ni para quien descargan tus archivos)",
          13: "Soporte prioritario",
        },
      },
    },
  },

  billing: {
    title: "Facturación",
    description:
      "Página donde cambiar tus datos de facturación en tu cuenta de ydray",
    messages: {
      title: "YDRAY trabaja con Stripe para simplificar la facturación",
      loading: "Cargando...",
      success:
        "Para gestionar tu subscripción y facturas, haz click en el siguiente enlace",
      link: "Click aquí",
      error: "Ha ocurrido un error",
      empty: "No existen datos de facturación",
    },
  },

  personal: {
    title: "Datos Personales",
    description:
      "Página donde cambiar tus datos personales en tu cuenta de ydray",
    form: {
      companyName: {
        label: "Nombre/Nombre Empresa",
        placeholder: "Nombre/Nombre Empresa",
      },
      account: {
        title: "Datos de Cuenta",
        name: {
          label: "Nombre completo",
          placeholder: "Nombre",
        },
        email: {
          label: "Email",
          placeholder: "Email",
        },
        phone: {
          label: "Teléfono",
          placeholder: "Teléfono",
        },
        language: {
          label: "Idioma",
          placeholder: "Idioma",
        },
      },
      billing: {
        title: "Datos de Facturación",
        companyName: {
          label: "Nombre/Empresa",
          placeholder: "Nombre/Empresa",
        },
        line1: {
          label: "Linea 1",
          placeholder: "Línea 1",
        },
        line2: {
          label: "Línea 2",
          placeholder: "Línea 2",
        },
        zipcode: {
          label: "Código Postal",
          placeholder: "Código Postal",
        },
        country: {
          label: "País",
          placeholder: "País",
        },
        state: {
          label: "Estado/Provincia",
          placeholder: "Estado/Provincia",
        },
        city: {
          label: "Ciudad",
          placeholder: "Ciudad",
        },
        vat: {
          label: "Nº Ident. Fiscal",
          placeholder: "Nº Ident. Fiscal",
          tooltip: {
            title: "¿Qué es el Número de Identificación Fiscal?",
            rules: {
              1: "Solo se validará para países de la Unión Europea",
              2: "Debe empezar con el código del país europeo",
              3: "El país de la dirección y el código del país deben ser el mismo",
              4: "El formato es único por cada país",
            },
            link: "<container>Si necesitas ayuda, haz click <help_link>{{here}}</help_link>.</container>",
          },
        },
      },
    },
  },

  security: {
    title: "Seguridad",
    description:
      "Página donde cambiar tu contraseña o añadir 2FA a tu cuenta YDRAY",
    password: {
      title: "Cambiar contraseña",
      subtitle: "",
      steps: {
        1: {
          title: "Usa combinaciones únicas",
          title_short: "Usa combinaciones únicas",
          subtitle:
            "Mezcla letras mayúsculas y minúsculas, números y caracteres especiales. La contraseña debe tener una longitud mínima de 8 caracteres y máxima de 16.",
          subtitle_short:
            "Incluye mayúsculas, minúsculas, números y símbolos. Longitud recomendada: 8-16 caracteres.",
        },
        2: {
          title: "No reutilices contraseñas y evita información personal",
          title_short: "No reutilices contraseñas",
          subtitle:
            "Cada cuenta debe tener una clave diferente para mayor seguridad. Además, evita incluir tu nombre, fecha de nacimiento o palabras comunes en tus contraseñas, ya que los atacantes suelen probar combinaciones relacionadas con tu identidad.",
          subtitle_short:
            "Cada cuenta debe tener una clave diferente. Evita usar información personal.",
        },
        3: {
          title: "Cambia tus contraseñas periódicamente",
          title_short: "Cámbialas periódicamente",
          subtitle:
            "No basta con crear una buena contraseña, también es recomendable renovarla cada cierto tiempo. Actualízala al menos cada seis meses para reducir riesgos.",
          subtitle_short:
            "Renueva tus contraseñas al menos cada seis meses para mayor seguridad.",
        },
        4: {
          title: "Usa un gestor de contraseñas",
          title_short: "Usa un gestor de contraseñas",
          subtitle:
            "Estos programas almacenan y protegen tus claves de manera segura, generando contraseñas fuertes y únicas sin que tengas que recordarlas todas. Son una excelente estrategia para mejorar tu seguridad digital.",
          subtitle_short:
            "Almacena y genera claves seguras sin necesidad de recordarlas todas.",
        },
      },
    },
    mfa: {
      title_enable_mfa: "Activar 2FA",
      title_disable_mfa: "Desactivar 2FA",
      subtitle: "",
      steps: {
        1: {
          title:
            "Comienza asegurando tu cuenta descargando una aplicación de autenticación en tu móvil",
          subtitle:
            "Existen un montón de aplicaciones de autenticación disponibles y la mayoría son súper fáciles de usar. Además, no te preocupes, ¡todo el proceso te tomará solo unos minutos!",
          title_short: "Descarga una App de autenticación",
          subtitle_short: "Hay muchas opciones y son fáciles de usar",
        },
        2: {
          title:
            "Escanea el código QR con la aplicación o haz clic en el enlace proporcionado para continuar con la configuración",
          subtitle:
            "Así de sencillo es obtenerlo. La aplicación te guiará paso a paso para que no haya confusiones ni complicaciones en el proceso.",
          title_short: "Escanea el código QR",
          subtitle_short: "La App te guiará paso a paso",
        },
        3: {
          title:
            "Introduce el código temporal que genera tu aplicación para completar la verificación",
          subtitle:
            "Este código cambia cada pocos segundos en la aplicación, así que asegúrate de introducirlo rápidamente para no tener que regenerarlo.",
          title_short: "Introduce el código de la App",
          subtitle_short: "El código es temporal y cambia cada pocos segundos",
        },
        4: {
          title:
            "¡Y listo! Tu cuenta en YDRAY ahora está protegida con 2FA para mayor seguridad",
          subtitle:
            "Ya puedes respirar con tranquilidad sabiendo que la seguridad de tu cuenta ha mejorado significativamente gracias al 2FA.",
          title_short: "¡Listo! Tu cuenta está protegida con 2FA",
          subtitle_short: "La seguridad ha mejorado",
        },
      },
    },
  },

  custom: {
    title: "Personalizar",
    description: "Página donde personalizar tu cuenta YDRAY",
    link: {
      title: "Enlace personalizado",
      subtitle: "",
      add: {
        characteristics: {
          1: {
            title: "Genera enlaces personalizados con tu propio subdominio",
            subtitle:
              "Crea enlaces de descarga con tu propio subdominio, ofreciendo una experiencia más personalizada y profesional",
            title_short: "Enlaces personalizados",
            subtitle_short: "Enlaces de descarga con tu subdominio",
          },
          2: {
            title: "Facilita la gestión de tus descargas",
            subtitle:
              "Con un subdominio propio, gestionar y organizar tus enlaces de descarga es más sencillo y eficiente",
            title_short: "Gestión sencilla",
            subtitle_short: "Organiza fácilmente tus enlaces",
          },
          3: {
            title: "Refuerza tu marca con cada descarga",
            subtitle:
              "Utilizar tu subdominio en los enlaces de descarga mejora la visibilidad y credibilidad de tu marca",
            title_short: "Refuerza tu marca",
            subtitle_short: "Mejora la visibilidad y credibilidad",
          },
        },
      },
      show: {
        title: "Subdominio",
        subtitle:
          "Tus transferencias personalizadas podrán usar el siguiente subdominio",
      },
    },
    background: {
      title: "Fondos personalizados",
      subtitle: "",
      characteristics: {
        1: {
          title: "Dale un toque único a tus enlaces con fondos de imagen",
          subtitle:
            "Personaliza cada enlace de descarga con un fondo de imagen que refleje tu estilo y el de tu marca, creando una experiencia visual atractiva para tus usuarios",
          title_short: "Enlaces con fondo",
          subtitle_short: "Personaliza tus enlaces con imágenes",
        },
        2: {
          title: "Mejora la organización con fondos distintivos",
          subtitle:
            "Utiliza distintos fondos de imagen para diferenciar fácilmente entre tus enlaces de descarga, facilitando la organización y el acceso rápido",
          title_short: "Organización visual",
          subtitle_short: "Diferencia enlaces con imágenes",
        },
        3: {
          title: "Potencia tu marca con fondos personalizados",
          subtitle:
            "Los fondos de imagen en tus enlaces no solo embellecen, sino que también fortalecen la presencia de tu marca en cada interacción con los usuarios",
          title_short: "Marca visual",
          subtitle_short: "Refuerza tu marca con cada enlace",
        },
      },
    },
  },

  contact: {
    title: "Contacto",
    description: "Página de contacto con YDRAY",
    subtitle: "¿En qué podemos ayudar?",
    emailLb: "Email",
    email: "info@ydray.com",
    form: {
      name: "Nombre / Empresa",
      email: "Email",
      email2: "Repetir email",
      phone: "Número de teléfono",
      reason: "Motivo",
      reasonph: "Selecciona el motivo...",
      reasons: {
        1: "Información sobre los planes de YDRAY",
        2: "Necesito ayuda para subir archivos",
        3: "Necesito ayuda para descargar archivos",
        4: "Necesito ayuda al usar YDRAY",
        5: "Necesito ayuda con mi cuenta YDRAY",
        6: "Necesito ayuda con el proceso de pago",
        7: "Necesito ayuda para eliminar un enlace compartido",
        8: "Necesito ayuda con mi subdominio",
        9999: "Otro",
      },
      message: "Escribe tu mensaje",
      consent: {
        template:
          "<text>He leído, entiendo y acepto la <privacy_link>política de privacidad</privacy_link>.</text>",
        text: "Política de Privacidad",
      },
    },
  },

  uploads: {
    title: "Transferencias",
    description: "Resumen de transferencias de archivos de tu cuenta YDRAY",
    header: {
      title: "Hola, {{username}}",
      used_storage: "{{value}} utilizado",
      total_storage: "{{value}} total",
      used_storage_ph: "{{value}}% de espacio utilizado",
      uploads: "transferencias",
      uploads_ph: "{{count}} transferencias",
      files: "archivos",
      files_ph: "{{count}} archivos",
    },
    body: {
      results: "{{count}} resultados",
    },
    table: {
      columns: {
        idTransfer: "ID",
        server: "Servidor",
        password: "Contraseña",
        title: "Título",
        message: "Comentario",
        dispatched: "Fecha Creación",
        newest: "Nuevas primero",
        oldest: "Antigüas primero",
        until: "Caducidad",
        num_files: "Archivos",
        size: "Tamaño",
        actions: "Acciones",
      },
      rows: {
        file_one: "archivo",
        file_other: "archivos",
        fileWithCount_one: "{{count}} archivo",
        fileWithCount_other: "{{count}} archivos",
      },
      addons: {
        lock: "Transferencia con Contraseña",
        customLink: "Transferencia con Link Personalizado",
        background: "Transferencia con Fondo Personalizado",
      },
      actions: {
        copy: "Copiar",
        share: "Compartir",
        delete: "Borrar",
        expand: "Expandir",
        detail: "Detalle",
        download: "Descargar",
        stats: "Info. Descargas",
        menu: {
          copy: "Copiar",
          share: "Compartir",
          delete: "Borrar",
        },
      },
    },
    message: {
      delete_transfer:
        "Todos los archivos asociados se eliminarán al borrar la transferencia, ¿desea continuar?",
      delete_file:
        "Se borrará el archivo asociado a la transferencia, ¿desea continuar?",
      delete_transfer_file:
        "Se borrará la transferencia al eliminar el único archivo, ¿desea continuar?",
    },
  },

  expire_delete_transfer_dialog: {
    header: {
      title: "Caducar/Borrar",
      subtitle: "¿Quieres caducar o borrar la transferencia?",
    },
    body: {
      delete_message:
        "La transferencia dejará de estar disponible y todos los archivos e información asociada serán eliminados",
      expire_message:
        "La transferencia deja de estar disponible, pero los archivos siguen guardados. Puedes reactivar la transferencia cuando quieras",
    },
    footer: {},
    messages: {
      expired_transfer: "La transferencia se ha caducado correctamente 👍",
    },
  },

  subdomain_dialog: {
    header: {
      title: "Subdominio",
      subtitle: "Edita tu subdominio personalizado",
    },
    body: {
      form: {
        example: {
          label: "Tu subdominio",
          placeholder: "No hay un subdominio configurado",
        },
        subdomain: {
          label: "Subdominio",
          placeholder: "<tu subdominio>",
          tooltip: {
            title: "Reglas de validación del subdominio",
            rules: {
              1: "Puede contener letras y números",
              2: "Solo letras minúsculas",
              3: "No puede empezar o terminar por guión",
              4: "No puede contener dos guiones seguidos",
              5: "La longitud será entre 6 y 26 caracteres",
              6: "Algunas palabras no están permitidas",
            },
            delete: "Deja en blanco el campo si quieres borrar tu subdominio",
          },
        },
      },
    },
    footer: {},
  },

  background_dialog: {
    header: {
      title: "Fondos",
      subtitle: "Edita tus fondos personalizados",
      help: {
        tooltip: {
          title: "Características de tus fondos",
          rules: {
            1: "El tamaño máximo es de 3MB",
            2: "Las dimensiones deben ser mayores a 1024x768",
            3: "Las extensiones permitidas son [jpg, jpeg, gif y png]",
            4: "Puedes tener hasta un máximo de 25 fondos",
          },
        },
      },
    },
    body: {
      upload_image: {
        title: "Subir Fondo",
        subtitle: "Haz click o arrastra aquí para subir un nuevo fondo",
      },
    },
    footer: {},
    confirm: {
      header: {
        title: "Confirmación",
        subtitle: "Es necesaria tu confirmación",
      },
      body: {
        template:
          "<container><p>Vas a eliminar este archivo permanentemente.</p><p>¿Deseas continuar?</p></container>",
      },
    },
  },

  uploads_detail: {
    title: "Detalle Transferencia",
    description: "Detalle de una transferencia de archivos en ydray",
    header: {
      title: "Detalle Transferencia",
    },
    body: {
      transfer: {
        title: "Transferencia de {{size}}",
        menu: {
          edit: "Editar",
          password: "Contraseña",
          undo: "Deshacer",
          save: "Guardar",
          delete: "Borrar",
          copy: "Copiar",
          share: "Compartir",
          expand: "Expandir",
        },
        form: {
          title: "Título",
          titleph: "(Vacío)",
          background: "Fondo",
          backgroundph: "(Vacío)",
          dispatched: "Fecha Creación",
          dispatchedph: "(Vacío)",
          until: "Fecha Caducidad",
          untilph: "(Vacío)",
          transferLink: "Link Transferencia",
          transferLinkph: "(Vacío)",
          transferCustomLink: "Link personalizado",
          transferCustomLinkph: "(Vacío)",
          message: "Mensaje",
          messageph: "(Vacío)",
        },
        customLinkPreview: {
          title: "Custom Link Preview",
        },
        messages: {
          invalid_subdomain:
            "Para editar el link personalizado, debes indicar tu subdominio en la página Personalizar",
        },
      },
      files: {
        title_one: "Archivo",
        title_other: "Archivos",
        titleWithCount_one: "{{count}} archivo",
        titleWithCount_other: "{{count}} archivos",
        table: {
          columns: {
            idFile: "Id Archivo",
            idTransfer: "Id Transferencia",
            fileName: "Nombre",
            fileSize: "Tamaño",
            countDownload: "Descargas",
            actions: "Acciones",
            deleted: "Borrado",
          },
          rows: {
            download_one: "descarga",
            download_other: "descargas",
            downloadWithCount_one: "{{count}} descarga",
            downloadWithCount_other: "{{count}} descargas",
          },
        },
      },
      file_detail: {
        title: "Detalle del Archivo",
        table: {
          columns: {
            country: "País",
            state: "Provincia",
            city: "Ciudad",
            device: "Dispositivo",
          },
        },
      },
    },
  },

  transfer_background: {
    header: {
      title: "Selecciona un fondo",
      subtitle: "Elige un fondo para personalizar tus transferencias",
      help: {
        tooltip: {
          title: "Características de tus fondos",
          rules: {
            1: "El tamaño máximo es de 3MB",
            2: "Las dimensiones deben ser mayores a 1024x768",
            3: "Las extensiones permitidas son [jpg, jpeg, gif y png]",
            4: "Puedes tener hasta un máximo de 25 fondos",
          },
        },
      },
    },
    body: {
      upload_image: {
        title: "Subir Fondo",
        subtitle: "Haz click o arrastra aquí para subir un nuevo fondo",
      },
    },
    footer: {},
  },

  landing: {
    title: "Enviar y compartir archivos grandes hasta 10 GB gratis",
    description: `
      YDRAY es la forma más rápida y fácil de enviar, transferir y compartir tus archivos grandes y pesados con la máxima seguridad y privacidad hasta 10 GB gratis
    `,
    hero: {
      title:
        "YDRAY permite compartir y enviar archivos de manera sencilla y privada",
      subtitle:
        "Con YDRAY puedes enviar y compartir archivos grandes de forma segura de hasta 10 GB gratis, sin necesidad de registro y con descargas ilimitadas",
      button: {
        files: {
          title: "Archivos",
          subtitle: "Empieza a Compartir",
        },
        privacy: {
          title: "Privacidad",
          subtitle: "Descubre el stándar",
        },
      },
      img: {
        title:
          "YDRAY permite compartir y enviar tus archivos grandes de manera sencilla, rápida y privada",
        alt: "YDRAY permite compartir y enviar tus archivos grandes de manera sencilla, rápida y privada",
      },
    },
    body: {
      about_section: {
        title: "Sobre nosotros",
        description:
          "Más de 25.000 personas confian en YDRAY para enviar y compartir sus archivos grandes a diario",
      },
      speech_section: {
        title:
          "Más de 25.000 personas confian en YDRAY para enviar y compartir sus archivos grandes a diario",
        msg1: `
        <span class="msg">
          "La velocidad para enviar y compartir archivos grandes en YDRAY es impresionante."
        </span>
        <span class="firm">Diego S.</span>
      `,
        msg2: `
        <span class="msg">
          "Me encanta YDRAY para compartir y enviar archivos grandes y pesados."
        </span>
        <span class="firm">Sara M.</span>
      `,
        msg3: `
        <span class="msg">
          "Me gusta que se pueda compartir los archivos sin necesidad de registro en YDRAY."
        </span>
        <span class="firm">Nadia B.</span>
      `,
        msg4: `
        <span class="msg">
          "Recomiendo YDRAY para enviar y compartir archivos grandes de forma rápida y segura."
        </span>
        <span class="firm">Jaime Q.</span>
      `,
        msg5: `
        <span class="msg">
          "He usado YDRAY para enviar y compartir archivos grandes y no he tenido problemas."
        </span>
        <span class="firm">José S.</span>
        `,
      },
      how_section: {
        subtitle: "cómo funciona YDRAY",
        title: "Fácil y sencillo",
        step1: {
          title: "Sube tus archivos",
          subtitle:
            "Acepte los terminos legales y suba sus archivos grandes a enviar y compartir.",
        },
        step2: {
          title: "Personaliza tu envío",
          subtitle: "Nombre, descripción, contraseña y mucho más.",
        },
        step3: {
          title: "Comparte tu enlace",
          subtitle: "Con quien quieras y como quieras.",
        },
        help: {
          title: "¿Tienes alguna duda?",
          subtitle: "¡Contacta con nosotros y te ayudaremos!",
        },
      },
      plans_section: {
        subtitle: "Planes de YDRAY",
        title: "Un plan para ti",
        description: `
          <p>
            YDRAY ofrece diferentes planes de pago que te permiten
            disfrutar de funciones adicionales al enviar y compartir tus
            archivos grandes. Con el plan YDRAY Pro, puedes enviar archivos
            grandes de hasta 1204 GB. Además, obtienes un mayor control sobre
            tus enlaces de descarga y la posibilidad de establecer fechas
            de descarga.
          </p>
        `,
      },
      why_section: {
        subtitle: "¿Por qué YDRAY?",
        title: "Enviar archivos grandes más facil que nunca",
        description: `
        <p>
          YDRAY ofrece una alternativa sólida a otras plataformas de transferencia de archivos al brindar una experiencia
          excepcional al enviar, transferir y compartir archivos grandes de forma rápida segura y con la máxima privacidad.
        </p>
        `,
      },
      secure_section: {
        subtitle: "¿Es seguro YDRAY?",
        title: "Compartir archivos de forma segura",
        description: `
        <p>
          Con YDRAY, puedes disfrutar de una plataforma fácil de usar y segura que te permite enviar archivos grandes.
          YDRAY prioriza la seguridad y la privacidad, ofreciendo cifrado de extremo a extremo para todas las
          transferencias de archivos. Esto significa que sus archivos están protegidos contra accesos no autorizados e
          interceptación durante la transmisión.
        </p>
        `,
      },
      privacy_section: {
        subtitle: "¿Cómo garantiza YDRAY la máxima privacidad?",
        title: "Envía y comparte archivos grandes con la máxima privacidad",
        description: `
          <p>
            YDRAY garantiza máxima privacidad a la hora de enviar, compartir y transferir archivos grandes aplicando las políticas
            más estrictas en materia de protección de datos como la Ley General de Protección de Datos europea (RGPD)
            Reglamento (UE) 2016/679.
          </p>
          <p>
            YDRAY tiene una política de privacidad clara y transparente que describe cómo se recopilan,
            utilizan y protegen los datos de los usuarios. Esta política cumple con las leyes y regulaciones de protección de datos
            aplicables y demuestra el compromiso de YDRAY con la privacidad de sus usuarios a la hora de enviar y compartir sus archivos grandes.
          </p>
        `,
      },
      tips_section: {
        subtitle: "Consejos para protegerte",
        title: "Consejos para proteger tu privacidad en Internet",
        tip1: {
          icon: "system",
          title: "Actualiza el sistema operativo",
          description: `
            <p>
              Tener actualizado el sistema operativo de su ordenador o dispositivo móvil le protegerá contra multitud de
              ciberamenazas.
            </p>
          `,
        },
        tip2: {
          icon: "password",
          title: "Utiliza contraseñas seguras",
          description: `
            <p>
              Usa contraseñas robustas de al menos 10 caracteres y que combinen letras, números y símbolos.
            </p>
          `,
        },
        tip3: {
          icon: "auth",
          title: "Usa autenticación 2FA",
          description: `
            <p>
              La mejor forma de proteger tu cuenta es activando un doble autenticación, a través de un código o el uso
              de aplicaciones de generación de códigos.
            </p>
          `,
        },
        tip4: {
          icon: "email",
          title: "Vigila los emails desconocidos",
          description: `
            <p>
              Mucho cuidado con los emails de fuentes desconocidas, evitar los enlaces o descargar archivos adjuntos.
            </p>
          `,
        },
        tip5: {
          icon: "wifi",
          title: "Cuidado con las WiFi públicas",
          description: `
            <p>
              Cuando utilice redes WIFI públicas evite realizar compras y/o acceder a servicios que requieran
              introducir una contraseña.
            </p>
          `,
        },
        tip6: {
          icon: "social",
          title: "Limita las redes sociales",
          description: `
            <p>
              ¡No publiques más información de la necesaria! Revisa quien puede acceder a tu información y
              publicaciones.
            </p>
          `,
        },
        tip7: {
          icon: "store",
          title: "Aplicaciones solo desde sitios oficiales",
          description: `
            <p>
              Instala las aplicaciones de los sitios oficiales de confianza (web desarrollador oficial, Play Store o Apple Store).
            </p>
          `,
        },
        tip8: {
          icon: "antivirus",
          title: "Usa un Antivirus",
          description: `
            <p>
              Procura que todos tus dispositivos cuenten con un software de seguridad de muy buena calidad protegiéndolos en todo momento.
            </p>
          `,
        },
        tip9: {
          icon: "cloud",
          title: "Realiza copias de seguridad",
          description: `
            <p>
              Lo mejor es siempre tener una copia de seguridad de la información de tu móvil y tu ordenador en la nube.
            </p>
          `,
        },
      },
    },
    footer: {
      press: "Prensa",
      contact: "Contacto",
      newsletter: "Newsletter",
      faq: "Preguntas Frecuentes",
      privacy_policy: "Política Privacidad",
      cookie_policy: "Política Cookies",
      legal_warn: "Aviso Legal",
      consent_cookies: "Configuración de Cookies",
      send_files: "Enviar Archivos",
      share_files: "Compartir Archivos",
    },
  },

  uploader_page: {
    title: "Enviar y compartir archivos grandes hasta 10 GB gratis",
    description: `
      YDRAY es la forma más rápida y fácil de enviar, transferir y compartir tus archivos grandes y pesados con la máxima seguridad y privacidad hasta 10 GB gratis
    `,
  },

  press: {
    title: "Prensa",
    description:
      "Página donde encontrar los enlaces a las noticias donde encontrar a ydray",
    content: `
    <h1>YDRAY en la prensa internacional</h1>
    <h2>Noticias</h2>
    <h3>2023</h3>
    <div class="news-item">
      <h4>
        <a href="https://www.tvn-2.com/casi-las-cinco/video-ydray-aplicacion-permite-descargar-10g_8_2058955.html"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="YDRAY es una aplicación que te permite descargar hasta 10G"
        >
          YDRAY es una aplicación que te permite descargar hasta 10G - (14/06/2023)
        </a>
      </h4>
      <p class="news-item-desc" title="Vídeo | YDRAY es una aplicación que te permite descargar hasta 10G - Casi Las Cinco | TVN Panamá">
        Vídeo | YDRAY es una aplicación que te permite descargar hasta 10G - Casi Las Cinco | TVN Panamá.
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.adslzone.net/como-se-hace/gmail/enviar-adjuntos-superar-limite/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Cómo enviar archivos adjuntos de más de 25 MB en Gmail"
        >
          Cómo enviar archivos adjuntos de más de 25 MB en Gmail - (13/03/2023)
        </a>
      </h4>
      <p class="news-item-desc" title="Truco para enviar archivos adjuntos de más de 50 MB en mensajes de correo electrónico de Gmail usando un servicio paralelo.">
      Truco para enviar archivos adjuntos de más de 50 MB en mensajes de correo electrónico de Gmail usando un servicio paralelo.
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.adslzone.net/listas/mejores-webs/alternativas-wetransfer/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Envía archivos grandes gratis con estas alternativas a WeTransfer"
        >
          Envía archivos grandes gratis con estas alternativas a WeTransfer - (07/03/2023)
        </a>
      </h4>
      <p class="news-item-desc" title="Las mejores alternativas a WeTransfer para enviar archivos grandes gratis por correo electrónico o por enlace y sin registro.">
      Las mejores alternativas a WeTransfer para enviar archivos grandes gratis por correo electrónico o por enlace y sin registro.
      </p>
    </div>
    <h3>2022</h3>
    <div class="news-item">
      <h4>
        <a href="https://www.semana.com/tecnologia/articulo/google-drive-asi-puede-liberar-espacio-en-su-cuenta/202231/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Google Drive: así puede liberar espacio en su cuenta"
        >
          Google Drive: así puede liberar espacio en su cuenta - (01/11/2022)
        </a>
      </h4>
      <p class="news-item-desc" title="Google Drive es utilizado para guardar archivos multimedia como fotos, videos y audios, entre otros documentos. ">
      Google Drive es utilizado para guardar archivos multimedia como fotos, videos y audios, entre otros documentos. 
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.adslzone.net/noticias/internet/mejores-webs-enviar-archivos-grandes-sin-limitacion-tamano/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="El tamaño no importa: las mejores webs para enviar archivos grandes por Internet"
        >
          El tamaño no importa: las mejores webs para enviar archivos grandes por Internet (26/09/2022)
        </a>
      </h4>
      <p class="news-item-desc" title="Enviar archivos por Internet es una tarea de lo más sencilla y con multitud de posibilidades. Sin embargo, a veces hay limitaciones por tamaño.">
      Enviar archivos por Internet es una tarea de lo más sencilla y con multitud de posibilidades. Sin embargo, a veces hay limitaciones por tamaño.
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.elsuplemento.es/premiado/ydray-premio-nacional-de-tecnologia-2022-en-la-categoria-soluciones-tecnologicas"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="YDRAY, Premio Nacional de Tecnología 2022 en la categoría Soluciones Tecnológicas | El Suplemento"
        >
          YDRAY, Premio Nacional de Tecnología 2022 en la categoría Soluciones Tecnológicas - (25/05/2022)
        </a>
      </h4>
      <p class="news-item-desc" title="YDRAY es la plataforma de gestión y envío de archivos online de referencia en España y América">
      YDRAY es la plataforma de gestión y envío de archivos online de referencia en España y América
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://computerhoy.com/tutoriales/tecnologia/como-mandar-emails-adjuntos-25-mb-gmail-970223"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Cómo mandar emails adjuntos de más de 25 MB en Gmail"
        >
          Cómo mandar emails adjuntos de más de 25 MB en Gmail - (27/01/2022)
        </a>
      </h4>
      <p class="news-item-desc" title="Te contamos como puedes mandar un archivo adjunto de más de 35 GB en un correo electrónico de Gmail. Es mucho más sencillo de lo puedes imaginar.">
      Te contamos como puedes mandar un archivo adjunto de más de 35 GB en un correo electrónico de Gmail. Es mucho más sencillo de lo puedes imaginar.
      </p>
    </div>
    <div class="news-item">
      <h4 class="news-item-title">
        <a href="https://www.emprendedores.es/ayudas/estudio-de-ydray-com-sobre-uso-de-la-nube/"
          class="news-item-link link"
          target="_blank"
          title="Ydray.com estudio sobre el uso de la nube en 2021"
          rel="noopener noreferrer">
            Ydray.com estudio sobre el uso de la nube en 2021 - (02/12/2021)
        </a>
      </h4>
      <p
      class="news-item-desc"
      title="Ydray.com, la empresa de transferencia de archivos, presenta los resultados de su estudio sobre hábitos y usos de la nube. Los usuarios de este tipo de plataformas la emplean para enviar archivos de entre 100 y 500 megas, tanto para fines profesionales como particulares."
      >
      Ydray.com, la empresa de transferencia de archivos, presenta los resultados de su estudio sobre hábitos y usos de la nube.
      Los usuarios de este tipo de plataformas la emplean para enviar archivos de entre 100 y 500 megas, tanto para fines profesionales como particulares.
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://vistarmagazine.com/como-enviar-archivos-pesados-desde-cuba-sin-usar-wetransfer/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="¿Cómo enviar archivos pesados desde Cuba sin usar WeTransfer?"
        >
          ¿Cómo enviar archivos pesados desde Cuba sin usar WeTransfer? (09/07/2021)
        </a>
      </h4>
      <p class="news-item-desc" title="Si necesitas enviar archivos pesados desde Cuba hay más de una manera de hacerlo. Descubre aquí otras opciones además de la popular WeTransfer">
      Si necesitas enviar archivos pesados desde Cuba hay más de una manera de hacerlo. Descubre aquí otras opciones además de la popular WeTransfer
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://miracomohacerlo.com/enviar-videos-pesados-imgenes-audios-archivos-whatsapp/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Cómo Enviar Vídeos Pesados, Imágenes, Audios y Archivos de más de 100 MB por WhatsApp | Mira Cómo Hacerlo"
        >
          Cómo Enviar Vídeos Pesados, Imágenes, Audios y Archivos de más de 100 MB por WhatsApp - (31/03/2021)
        </a>
      </h4>
      <p class="news-item-desc" title="¡No es imposible! Hay distintas formas de compartir archivos, fotos y videos de más de 100 MB por WhatsApp y aquí te contamos cómo ?">
      ¡No es imposible! Hay distintas formas de compartir archivos, fotos y videos de más de 100 MB por WhatsApp y aquí te contamos cómo ?
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://miracomohacerlo.com/que-es-wetransfer-y-como-funciona/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="WeTransfer: ¿Qué es y como funciona? Aprende cómo Enviar y Recibir Archivos Pesados | Mira Cómo Hacerlo"
        >
          WeTransfer: ¿Qué es y como funciona? Aprende cómo Enviar y Recibir Archivos Pesados - (28/02/2021)
        </a>
      </h4>
      <p class="news-item-desc" title="¿Cuáles son los pasos para poder enviar archivos pesados a través de WeTransfer ? Conoce: ¿Qué es y como funciona?">
      ¿Cuáles son los pasos para poder enviar archivos pesados a través de WeTransfer ? Conoce: ¿Qué es y como funciona?
      </p>
    </div>
    <h3>2020</h3>
    <div class="news-item">
      <h4>
        <a href="https://www.tekcrispy.com/2020/11/11/ydray-transferir-archivos/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="YDRAY, un servicio para transferir archivos de hasta 10GB gratis"
        >
          YDRAY, un servicio para transferir archivos de hasta 10GB gratis - (11/11/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="YDRAY es un sitio web en donde podrás transferir archivos de hasta 10GB de forma segura y completamente gratuita.">
      YDRAY es un sitio web en donde podrás transferir archivos de hasta 10GB de forma segura y completamente gratuita.
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://intereconomia.com/noticia/ydray-amplia-su-servicio-gratuito-de-envio-de-archivos-online-hasta-los-10-gb-20201026-1300/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="YDRAY amplía su servicio gratuito de envío de archivos online hasta los 10 Gb"
        >
          YDRAY amplía su servicio gratuito de envío de archivos online hasta los 10 Gb - (20/10/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="El nuevo contexto generado por la actual crisis del Covid 19 ha cambiado la vida y los hábitos de todo el mundo, hecho ante el que YDRAY no ha podido permanecer impasible, lo que le ha llevado a aplicar una serie de medidas en su versión gratuita de la plataforma Ydray.com">
      El nuevo contexto generado por la actual crisis del Covid 19 ha cambiado la vida y los hábitos de todo el mundo, hecho ante el que YDRAY no ha podido permanecer impasible, lo que le ha llevado a aplicar una serie de medidas en su versión gratuita de la plataforma Ydray.com
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.xataka.com/servicios/21-servicios-gratis-para-enviar-archivos-grandes#:~:text=Ydray,a%20un%20m%C3%A1ximo%20de%2020."
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="21 servicios gratis para enviar archivos grandes"
        >
          21 servicios gratis para enviar archivos grandes - (29/09/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="Tener que compartir grandes cantidades de información es una necesidad bastante habitual en algunos trabajos y también en el ámbito del ocio. Una sesión de...">
      Tener que compartir grandes cantidades de información es una necesidad bastante habitual en algunos trabajos y también en el ámbito del ocio. Una sesión de...
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.europapress.es/portaltic/internet/noticia-servicios-gratuitos-permiten-enviar-archivos-pesados-20200927130036.html"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Servicios gratuitos que permiten enviar archivos pesados"
        >
          Servicios gratuitos que permiten enviar archivos pesados - (27/09/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="Hoy en día son muchas las personas que necesitan compartir archivos de gran peso de forma...">
      Hoy en día son muchas las personas que necesitan compartir archivos de gran peso de forma...
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://geekinsider.com/ydray-an-emerging-yet-robust-file-sharing-solution/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="YDRAY: An Emerging Yet Robust File Sharing Solution"
        >
          YDRAY: An Emerging Yet Robust File Sharing Solution - (02/10/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="Based out of Europe, YDRAY is a file transfer service that allows you to share large files of up to 10 GB each. The easy-to-use solution allows you to directly share these files with designated">
      Based out of Europe, YDRAY is a file transfer service that allows you to share large files of up to 10 GB each. The easy-to-use solution allows you to directly share these files with designated
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://roastbrief.com.mx/2020/10/ydray-com-amplia-su-servicio-gratuito-con-motivo-de-la-situacion-excepcional/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Ydray.com amplía su servicio gratuito con motivo de la situación excepcional"
        >
          Ydray.com amplía su servicio gratuito con motivo de la situación excepcional - (01/10/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="YDRAY es una plataforma para el envío gratuito online de archivos de hasta 5 Gb (actualmente 10Gb) de forma sencilla">
      YDRAY es una plataforma para el envío gratuito online de archivos de hasta 5 Gb (actualmente 10Gb) de forma sencilla
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.eluniversal.com.mx/techbit/cinco-herramientas-para-enviar-archivos-pesados/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Cinco herramientas para enviar archivos pesados"
        >
          Cinco herramientas para enviar archivos pesados - (03/05/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="Con estos servicios podrás enviar archivos grandes sin preocuparte de restricciones de tamaño">
      Con estos servicios podrás enviar archivos grandes sin preocuparte de restricciones de tamaño
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.dineroenimagen.com/management/lista-de-apps-y-sitios-premium-que-ahora-son-gratis/121197"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Lista de apps y sitios premium que ahora son gratis"
        >
          Lista de apps y sitios premium que ahora son gratis - (02/04/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="Muchas, en realidad, muchas compañías han estado apoyando la situación actual poniendo sus servicios de forma gratuita para todas las pers">
      Muchas, en realidad, muchas compañías han estado apoyando la situación actual poniendo sus servicios de forma gratuita para todas las pers
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.emprendedores.es/ayudas/ayuda-crear-empresa-negocio/recursos-gratuitos-emprendedores/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Recursos gratuitos a disposición de los emprendedores en tiempos de crisis - Emprendedores"
        >
          Recursos gratuitos a disposición de los emprendedores en tiempos de crisis - Emprendedores - (19/03/2020)
        </a>
      </h4>
      <p class="news-item-desc" title="La mayoría de estos recursos han sido dispuestos de forma gratuita por otros emprendedores para ayudar a sus colegas en distintas áreas de negocio ante la situación actual. Estos son algunos de los que se ofrecen.">
      La mayoría de estos recursos han sido dispuestos de forma gratuita por otros emprendedores para ayudar
      a sus colegas en distintas áreas de negocio ante la situación actual. Estos son algunos de los que se ofrecen.
      </p>
    </div>
    <h3>2019</h3>
    <div class="news-item">
      <h4>
        <a href="https://www.businessinsider.es/7-plataformas-servicios-compartir-gratis-archivos-5gb-501917"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Estas 7 plataformas y servicios te permitirán compartir archivos de más de 5GB online y gratis"
        >
          Estas 7 plataformas y servicios te permitirán compartir archivos de más de 5GB online y gratis - (26/10/2019)
        </a>
      </h4>
      <p class="news-item-desc" title="Enviar archivos de gran tamaño a otras personas es posible gracias a distintas plataformas gratuitas, te contamos cuáles son algunas de las más fiables y cómodas.">
      Enviar archivos de gran tamaño a otras personas es posible gracias a distintas plataformas gratuitas, te contamos cuáles son algunas de las más fiables y cómodas.
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.businessinsider.es/7-plataformas-servicios-compartir-gratis-archivos-5gb-501917"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="7 plataformas y servicios para compartir gratis archivos de más de 5GB"
        >
          7 plataformas y servicios para compartir gratis archivos de más de 5GB - (26-10-2019)
        </a>
      </h4>
      <p class="news-item-desc" title="Enviar archivos de gran tamaño a otras personas es posible gracias a distintas plataformas gratuitas, te contamos cuáles son algunas de las más fiables y cómodas.">
      Enviar archivos de gran tamaño a otras personas es posible gracias a distintas plataformas gratuitas, te contamos cuáles son algunas de las más fiables y cómodas.
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.tusequipos.com/2019/07/06/10-recursos-gratuitos-para-compartir-archivos-grandes/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="10 recursos gratuitos para compartir archivos grandes"
        >
          10 recursos gratuitos para compartir archivos grandes - (06/07/2019)
        </a>
      </h4>
      <p class="news-item-desc" title="¿Estas buscando opciones para compartir archivos grandes con tus contactos?">
      ¿Estas buscando opciones para compartir archivos grandes con tus contactos?
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.interempresas.net/TIC/Articulos/245230-Guardar-archivos-en-la-nube-Que-tener-en-cuenta.html"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="¿Qué tener en cuenta para guardar archivos en la nube?"
        >
          ¿Qué tener en cuenta para guardar archivos en la nube? - (09/05/2019)
        </a>
      </h4>
      <p class="news-item-desc" title="El almacenamiento de archivos ha evolucionado espectacularmente en los últimos 30/40 años. Empezamos por guardar nuestros datos y archivos informáticos en voluminosos equipos de hardware. Después, se pasó a los discos duros portátiles">
      El almacenamiento de archivos ha evolucionado espectacularmente en los últimos 30/40 años. Empezamos por guardar nuestros datos
      y archivos informáticos en voluminosos equipos de hardware. Después, se pasó a los discos duros portátiles
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://www.muycomputer.com/2019/04/08/como-enviar-archivos-pesados-gratis/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="9 herramientas para enviar archivos pesados gratis por Internet"
        >
          9 herramientas para enviar archivos pesados gratis por Internet - (08/04/2019)
        </a>
      </h4>
      <p class="news-item-desc" title="Aunque el correo electrónico o la mensajería instantánea son fundamentales en nuestro día a día, también tienen limitaciones. Una de las más importantes es el tamaño máximo de los archivos que podemos enviar adjuntos y, para ayudaros a solventarla, en este práctico recopilamos nuestras nueve soluciones favoritas para solucionar este problema.">  
      Aunque el correo electrónico o la mensajería instantánea son fundamentales en nuestro día a día, también tienen limitaciones.
      Una de las más importantes es el tamaño máximo de los archivos que podemos enviar adjuntos y, para ayudaros a solventarla,
      en este práctico recopilamos nuestras nueve soluciones favoritas para solucionar este problema.
      </p>
    </div>
    <div class="news-item">
      <h4>
        <a href="https://applicantes.com/ydray-renueva-competir-dropbox-wetransfer/"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="YDRAY se renueva para competir con Dropbox y Wetransfer"
        >
          YDRAY se renueva para competir con Dropbox y Wetransfer - (04/01/2019)
        </a>
      </h4>
      <p class="news-item-desc" title="YDRAY, el servicio para enviar archivos online de gran tamaño de origen español, ha iniciado 2019 con una renovación de su plataforma. Ydray.com ha añadido tres grandes novedades. En primer lugar, sus usuarios de la versión gratuita ya tienen la posibilidad de proteger los archivos con una c">
      YDRAY, el servicio para enviar archivos online de gran tamaño de origen español, ha iniciado 2019 con una renovación de su plataforma. Ydray.com ha añadido tres grandes novedades. En primer lugar, sus usuarios de la versión gratuita ya tienen la posibilidad de proteger los archivos con una c
      </p>
    </div>
    <h3>2018</h3>
    <div class="news-item">
      <h4>
        <a href="https://tools.robingood.com/24188/send-and-share-files-as-large-as-5gb-without-using-email-ydray"
          class="news-item-link link"
          target="_blank"
          rel="noopener noreferrer"
          title="Send and share files as large as 5GB without using email: YDRAY"
        >
          Send and share files as large as 5GB without using email: YDRAY - (15/01/2018)
        </a>
      </h4>
      <p class="news-item-desc" title="Free web app that allows to send files as large as 5GB to anyone without registration or login. Free version allows to distribute files to up to 20 recipients and to include as many as 50 files in one-go. Files sent are stored and made available for 7 days">
      Free web app that allows to send files as large as 5GB to anyone without registration or login. Free version allows to distribute files to up to 20 recipients and to include as many as 50 files in one-go. Files sent are stored and made available for 7 days
      </p>
    </div>
    `,
  },

  faq: {
    title: "Preguntas Frecuentes",
    description: "Página de preguntas frecuentes de YDRAY",
    content: `
    <h1>Preguntas Frecuentes</h1>
    <h2>¿Cómo se puede enviar un archivo utilizando Ydray.com?</h2>
    <p>Para enviar un archivo usando Ydray.com, simplemente visite la página web y haga clic en el botón <b>Agregar archivos</b>.</p>
    <p>Luego, seleccione o arrastre y suelte el archivo(s) que desea enviar desde su ordenador.</p>
    <p>Puede agregar un mensaje o direcciones de correo electrónico de destinatarios y luego hacer clic en el botón <b>Enviar</b> para comenzar la carga.</p>
    <p>Si se registra en Ydray.com, también puede elegir cuándo se eliminará el enlace y configurar una contraseña.</p>
    <h2>¿Cómo recibo un archivo utilizando Ydray.com?</h2>
    <p>Cuando alguien le envía un archivo utilizando Ydray.com, recibirá una notificación por correo electrónico con un enlace de descarga.</p>
    <p>Simplemente haga clic en el enlace para descargar el archivo.</p>
    <h2>¿Existe un límite en el tamaño de archivo que puedo enviar con Ydray.com?</h2>
    <p>Sí, Ydray.com tiene un límite de 10 GB por transferencia.</p>
    <p>Si necesita enviar archivos más grandes, puede utilizar su servicio de pago, YDRAY Pro.</p>
    <h2>¿Es seguro utilizar Ydray.com para la transferencia de archivos?</h2>
    <p>Sí, Ydray.com es una plataforma segura que utiliza cifrado de extremo a extremo para todas las transferencias de archivos.</p>
    <p>Esto significa que sus archivos están protegidos contra el acceso y la interceptación no autorizados durante la transmisión.</p>
    <h2>¿Por qué debería usar Ydray.com en lugar de otras plataformas de transferencia de archivos?</h2>
    <p>Hay algunas diferencias clave que pueden hacer que Ydray.com sea una mejor opción que otros servicios de envio y transferencia de archivos":</p>
    <h3>Seguridad</h3>
    <p>Ydray.com prioriza la seguridad y la privacidad, ofreciendo cifrado de extremo a extremo para todas las transferencias de archivos. Esto significa que sus archivos están protegidos contra accesos no autorizados e interceptación durante la transmisión.</p>
    <h3>Tamaño de archivo ilimitado</h3>
    <p>Con Ydray.com, puede enviar archivos de hasta 10 GB por transferencia, mientras que otras plataformas de transferencia y envio de archivos tienen un límite de 2 GB por transferencia.</p>
    <h3>Sin anuncios ni distracciones</h3>
    <p>Ydray.com no muestra anuncios ni otras distracciones durante el proceso de transferencia, mientras que otros muestran anuncios y mensajes promocionales.</li>
    <h3>Cargas más rápidas</h3>
    <p>Ydray.com utiliza una infraestructura de carga altamente optimizada y escalable, lo que permite una carga de archivos más rápida en comparación con otros proveedores de servicios.</p>
    <p>En general, Ydray.com ofrece una experiencia de transferencia de archivos más segura, personalizable y profesional en comparación con otras plataformas de transferencia de archivos.</p>
    `,
  },

  privacy: {
    title: "Política de Privacidad",
    description: "Política de privacidad de YDRAY",
    content: `
    <h1>Política de Privacidad</h1>
    <p>De conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos (en adelante, RGPD).</p>
    <h2>¿Quién es el responsable del tratamiento de sus datos?</h2>
    <div class="table-container">
      <table>
        <tr><td>Nombre</td><td>RECICLAONLINE S.L.</td></tr>
        <tr><td>CIF</td><td>B13538053</td></tr>
        <tr><td>Dirección</td><td>Tr.ª Manzana 10, 13300, Valdepeñas, C. Real</td></tr>
        <tr><td>Email</td><td><a class="link" href="mailto:privacidad@ydray.com" target="_blank" title="Enviar email a privacidad@ydray.com">privacidad@ydray.com</a></td>
        </tr>
      </table>
    </div>
    <p>En primer lugar queremos agradecerte que uses nuestro servicio. El hecho de que estés leyendo ahora mismo este punto indica que la privacidad es tan importante para ti como lo es para nosotros, ENHORABUENA!!!</p>
    <h2>¿En qué nos diferenciamos de otros servicios?</h2>
    <p>Uno de nuestros principales valores añadidos es la dura legislación que tenemos que cumplir al ser una empresa Española.</p>
    <p>Es fácil comprobar cómo grandes proveedores de “otros” servicios se remiten a leyes o tratados extranjeros, (principalmente leyes de California) y no nos informan de la ubicación física de sus servidores ni de las medidas de privacidad adoptadas. Esto tiene una repercusión muy importante sobre la privacidad de tus archivos, ya que normalmente, de modo inconsciente tendemos a pensar que al usar esos servicios tus archivos seguirán siendo Tus Archivos, cosa la cual, no siempre se cumple. En nuestro caso tus Archivos sí seguirán siendo tus archivos y nunca nos cederás derechos para que sean nuestros archivos.</p>
    <h2>Pero, ¿Cómo es posible esto?</h2>
    <p>Te pedimos que leas detenidamente el siguiente párrafo, pues es muy aclaratorio respecto a lo que concierne a privacidad.</p>
    <p>Es bastante común que con otros proveedores de servicios regidos bajo las leyes de California se cedan los derechos para poder divulgar, copiar, revelar datos almacenados, incluso poder modificar la propiedad y contenido del mismo.</p>
    <p>Sin embargo, nuestras condiciones de uso del servicio exponen que:</p>
    <p>YDRAY no tiene derecho alguno sobre marcas, nombres comerciales, signos distintivos, diseños y/o datos almacenados en sus servidores. Asimismo, no divulgará, copiará ni revelará ningún dato almacenado, por lo que nunca accederá a ellos a no ser que exista causa justificada por problemas derivados de procedimientos judiciales o por ser solicitados por las fuerzas y cuerpos de seguridad del estado. Por ello, YDRAY mantiene un registro de accesos de las direcciones IP de los usuarios.</p>
    <h2>¿Con qué finalidad tratamos sus datos?</h2>
    <p>Sus datos personales sólo se utilizarán para las siguientes finalidades:</p>
    <ol>
      <li>Registro, gestión y servicio de envío de archivos de gran capacidad a través de nuestra web a terceros.</li>
      <li>En el caso de ser usuario registrado, para el alta, gestionar el pago y la posterior gestión contable, fiscal y administrativa.</li>
      <li>Para el envío de newsletter relacionada con nuestros servicios, novedades y comunicaciones.</li>
    </ol>
    <h2>¿Cuál es la legitimación para el tratamiento de sus datos personales?</h2>
    <p>Medidas precontractuales en el caso de solicitudes de presupuesto u otras informaciones en relación a nuestros servicios.</p>
    <p>Si es usuario registrado para la ejecución de un contrato como cliente. El cumplimiento de obligaciones legales aplicables a la actividad, derivadas de la legislación mercantil y tributaria.</p>
    <p>Consentimiento expreso del usuario a través de la selección de la casilla check del registro donde verifica su consentimiento en el caso de envío de archivos y newsletter</p>
    <h2>¿Por cuánto tiempo conservamos sus datos personales?</h2>
    <p>Los datos serán conservados una semana desde que usted realice el envío.</p>
    <p>Si es usuario registrado, los datos personales que nos proporciona serán conservados mientras se mantenga nuestra relación contractual o mercantil. No obstante a partir de la fecha de la terminación de nuestra relación contractual o mercantil sus datos serán conservados:</p>
    <ul>
      <li>UN AÑO las derivadas de conexiones realizadas por internet con nuestro sitio web, correo electrónico y llamadas telefónicas de voz, mensajería instantánea, SMS o MMS En el caso que sea cliente nuestro sus datos serán conservados.</li>
      <li>CUATRO AÑOS a efectos fiscales. Los libros de contabilidad y otros libros registros obligatorios según la normativa tributaria que proceda (IRPF, IVA, IS, etc) así como los soportes documentales que justifiquen las anotaciones registradas en los libros.</li>
      <li>SEIS AÑOS se conservarán los datos personales incluidos en los libros obligatorios, documentación y justificantes concernientes a mi actividad profesional de acuerdo al Código de Comercio.</li>
      <li>INDEFINIDAMENTE en el caso de la newsletter, a no ser que revoque su consentimiento. En cada correo recibirá una opción para darse la baja en la suscripción.</li>
    </ul>
    <h2>¿Cómo hemos obtenido sus datos personales?</h2>
    <p>Los datos obtenidos no los ha proporcionado usted.</p>
    <h2>¿A qué destinatarios se comunicarán sus datos personales?</h2>
    <p>No existe ninguna cesión de datos prevista, salvo obligación legal en el caso de usuarios registrados para las obligaciones contables.</p>
    <h2>¿Cuáles son sus derechos cuando nos facilita sus datos personales?</h2>
    <p>Cualquier interesado podrá solicitar el ejercicio de los siguientes derechos:</p>
    <ul>
      <li>Derecho de acceso: El interesado tendrá derecho a obtener confirmación de si se están tratando o no datos personales que le conciernen.</li>
      <li>Derecho de rectificación: El interesado tendrá derecho a obtener la rectificación de los datos personales inexactos que le conciernan o incompletos.</li>
      <li>Derecho de supresión: El interesado tendrá derecho a obtener la supresión de los datos personales que le conciernan cuando los datos personales ya no sean necesarios en relación con los fines para los que fueron recogidos o tratados de otro modo.</li>
      <li>Derecho de limitación: Podrá solicitar la limitación del tratamiento de sus datos personales, en cuyo caso únicamente los conservaría para el ejercicio o la defensa de reclamaciones.</li>
      <li>Derecho a la portabilidad de sus datos: Por lo que puede solicitarnos que sus datos personales automatizados sean cedidos o transferidos a cualquier otra empresa que nos indique en un formato estructurado, inteligible y automatizado.</li>
      <li>Derecho de retirar el consentimiento: Usted tendrá derecho a retirar el consentimiento en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento antes de su retirada.</li>
      <li>Derecho de oposición: El interesado tendrá derecho a oponerse al tratamiento de sus datos.</li>
    </ul>
    <h2>¿Cómo podrá ejercitar estos derechos?</h2>
    <p>Ponemos a su disposición si nos lo solicitan los formularios donde podrá ejercitar estos derechos. Podrá solicitarnos en el correo <a href="mailto:privacidad@ydray.com" target="_blank" title="Enviar email a privacidad@ydray.com">privacidad@ydray.com</a> indicándonos el derecho que quiere ejercitar y le enviaremos el formulario correspondiente. El ejercicio de los derechos deberá llevarse a cabo mediante comunicación dirigida al correo electrónico o bien en el domicilio postal Travesía Manzana 10, 13300, Valdepeñas, Ciudad Real.</p>
    <h2>¿Quién puede ejercitar los derechos?</h2>
    <p>Los derechos de los interesados son personalísimos, por lo tanto, serán ejercidos por el titular de los datos acreditando debidamente su identidad.</p>
    <h2>¿Cuál será nuestra obligación cuando ejercita alguno de los derechos?</h2>
    <p>El responsable del tratamiento deberá contestar la solicitud que se le dirija en todo caso, con independencia de que figuren o no datos personales del afectado o interesado en sus tratamientos.</p>
    <p>En el caso de que la solicitud no reúna los requisitos especificados, el responsable del fichero deberá solicitar la subsanación de los mismos.</p>
    <p>El responsable de tratamiento responderá a las solicitudes en el plazo de un mes a partir de la recepción de la solicitud. Dicho plazo podrá prorrogarse otros dos meses en caso necesario, teniendo en cuenta la complejidad y el número de solicitudes. El responsable informará al interesado de cualquiera de dichas prórrogas en el plazo de un mes a partir de la recepción de la solicitud, indicando los motivos de la dilación.</p>
    <h2>Derecho de reclamación a la autoridad de control</h2>
    <p>Usted, podrá solicitar la tutela de derechos que no hayan sido debidamente atendidos a la Agencia Española de Protección de datos. Bien a través de la sede electrónica de su portal web (www.agpd.es), o bien mediante escrito dirigido a su dirección postal (C/ Jorge Juan, 6, 28001-Madrid).</p>
    <h2>¿Qué información recopilamos?</h2>
    <p>En general, puede usar el Sitio Web sin facilitar ninguna información de carácter personal. Disponemos de varias secciones en nuestra página web en las cuales existen formularios de recogida de datos personales que son necesarios para poder prestarle los servicios que nos solicita. Cuando nos remite alguno de estos formularios solicitándonos información, el usuario garantiza la autenticidad, exactitud y veracidad de toda la información que nos facilite, comprometiéndose a mantener actualizados los datos de carácter personal que nos facilite de forma que los mismos respondan, en todo momento, a su situación real. El Usuario será el único responsable de las manifestaciones falsas o inexactas y de los perjuicios que las mismas pudieran causar.</p>
    <h2>¿Qué medidas adoptamos para mantener segura su información?</h2>
    <p>Aplicamos medidas técnicas y físicas razonables para proteger la información que recogemos a través del Sitio Web.</p>
    `,
  },

  cookies: {
    title: "Política de Cookies",
    description: "Política de cookies de YDRAY",
    content: `
    <h1>Política de Cookies</h1>
    <p>Por favor, lea detenidamente esta declaración de privacidad antes de usar este Sitio, conocerá la forma en que usamos los cookies.</p>
    <p><b>El uso de este Sitio implica la aceptación de nuestra política de cookies. En caso contrario no use este Sitio.</b></p>
    <h2>1. Uso de cookies</h2>
    <h3>1.1. ¿Qué es una cookie?</h3>
    <p>Una cookie es un pequeño archivo, normalmente formado por letras y números, enviado por el servidor de nuestra web al archivo de cookies de su navegador. Ello permite a nuestra web recordar su presencia al establecerse una nueva conexión entre nuestro servidor y su navegador, así como mejorar la calidad del servicio analizando sus hábitos de navegación.</p>
    <h3>1.2. ¿Qué tipo de cookies emplea este Sitio?</h3>
    <h4>1.2.1. Cookies de sesión</h4>
    <p>Son cookies temporales que permanecen en el archivo de cookies de su navegador mientras está en nuestra página web. Estos cookies son necesarios para ciertas aplicaciones o funciones y permiten que este Sitio funcione adecuadamente.</p>
    <h4>1.2.2. Cookies de análisis</h4>
    <p>Son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web y para la elaboración de perfiles de navegación de los usuarios de dichos sitios con el fin de introducir mejoras en función de su análisis de los datos de uso que hacen los usuarios del servicio.</p>
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <td>Cookie</td>
            <td>Tipo</td>
            <td>Función</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>YDRAY_COM</td>
            <td>Sesión</td>
            <td>Correcto Funcionamiento de la página</td>
          </tr>
          <tr>
            <td>ydray</td>
            <td>Sesión</td>
            <td>Correcto Funcionamiento de la página</td>
          </tr>
          <tr>
            <td>st_ydy</td>
            <td>Sesión</td>
            <td>Correcto Funcionamiento de la página</td>
          </tr>
          <tr>
            <td>st_hmac</td>
            <td>Sesión</td>
            <td>Correcto Funcionamiento de la página</td>
          </tr>
          <tr>
            <td>csrf_cookie</td>
            <td>Sesión</td>
            <td>Correcto Funcionamiento de la página</td>
          </tr>
          <tr>
            <td>AcceptCookies</td>
            <td>Sesión</td>
            <td>Correcto Funcionamiento de la página</td>
          </tr>
          <tr>
            <td>_ga</td>
            <td>Analítica</td>
            <td>Obtener información de la navegación, medir y analizar la audiencia</td>
          </tr>
          <tr>
            <td>_gat</td>
            <td>Analítica</td>
            <td>Obtener información de la navegación, medir y analizar la audiencia</td>
          </tr>
          <tr>
            <td>_gid</td>
            <td>Analítica</td>
            <td>Obtener información de la navegación, medir y analizar la audiencia</td>
          </tr>
          <tr>
            <td>_asc</td>
            <td>Analítica</td>
            <td>Obtener información de la navegación, medir y analizar la audiencia</td>
          </tr>
          <tr>
            <td>_auc</td>
            <td>Analítica</td>
            <td>Obtener información de la navegación, medir y analizar la audiencia</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>En otros sitios de YDRAY se instalan cookies de terceros a todos sus visitantes, aunque no sean usuarios registrados en las correspondientes plataformas.</p>
    <h4>1.2.3. Google Analytics</h4>
    <p>Sus finalidades están descritas en la <a class="link" href="http://www.google.com/intl/es/policies/" target="_blank" title="Página de Políticas de Google">Página de Políticas de Google</a>.</p>
    <h4>1.2.4. Facebook</h4>
    <p>Sus finalidades están descritas en la <a class="link" href="https://www.facebook.com/help/cookies" target="_blank" title="Página de Cookies de Facebook">Página de Cookies de Facebook</a>.</p>
    <h4>1.2.5. X (Twitter)</h4>
    <p>Sus finalidades están descritas en la <a class="link" href="https://twitter.com/privacy" target="_blank" title="Página de Privacidad de X (Twitter)">Página de Privacidad de X (Twitter)</a>.</p>
    <h4>1.2.6. Youtube</h4>
    <p>Sus finalidades están descritas en la <a class="link" href="http://www.youtube.com/yt/policyandsafety/es/policy.html" target="_blank" title="Página de Privacidad de Youtube">Página de Privacidad de Youtube</a>.</p>
    <h2>2. Habilitación y deshabilitación de los cookies y de recursos similares</h2>
    <h3>2.1. Internet Explorer</h3>
    <p>Herramientas → Opciones de Internet → Privacidad → Configuración.</p>
    <p>Para más información, puede consultar el <a class="link" href="http://windows.microsoft.com/es-ES/windows/support" target="_blank" title="soporte de Microsoft">soporte de Microsoft</a> o la Ayuda del navegador.</p>
    <h3>2.2. Firefox</h3>
    <p>Herramientas → Opciones → Privacidad → Historial → Configuración Personalizada.</p>
    <p>Para más información, puede consultar el <a class="link" href="http://support.mozilla.org/es/home" target="_blank" title="soporte de Mozilla">soporte de Mozilla</a> o la Ayuda del navegador.</p>
    <h3>2.3. Chrome</h3>
    <p>Configuración → Mostrar opciones avanzadas → Privacidad → Configuración de contenido.</p>
    <p>Para más información, puede consultar el <a class="link" href="http://support.google.com/chrome/?hl=es" target="_blank" title="soporte de Google">soporte de Google</a> o la Ayuda del navegador.</p>
    <h3>2.4. Safari</h3>
    <p>Preferencias → Seguridad.</p>
    <p>Para más información, puede consultar el <a class="link" href="http://www.apple.com/es/support/safari/" target="_blank" title="soporte de Apple">soporte de Apple</a> o la Ayuda del navegador.</p>
    `,
  },

  legal_warn: {
    title: "Aviso Legal",
    description: "Aviso Legal de YDRAY",
    content: `
    <h1>Aviso Legal</h1>
    <p>Gracias por confiar en Ydray.com, en este punto te explicamos el objetivo del portal web y el cumplimiento con la Ley 34/2002.</p>
    <h2>Objetivo del portal web</h2>
    <p>Este portal web tiene como objetivo el poder enviar, compartir y almacenar archivos de gran tamaño entre usuarios, empresas y contactos de forma sencilla y segura.</p>
    <p>Nuestros servidores se encuentran localizados en Europa, siendo todos ellos servidores dedicados. Para nosotros, la privacidad de sus archivos es lo primero, por ello, huimos de la famosa nube, un sistema muy discutido en cuanto a privacidad y cobertura legal , y que utiliza la totalidad de nuestra competencia.</p>
    <h2>Información de cumplimento de Ley 34/2002</h2>
    <p>En cumplimiento de la Ley 34/2002, de 11 de Julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, le informamos que RECICLAONLINE SL, domiciliada en Travesía Manzana 10, 13300, Valdepeñas, Ciudad Real, con CIF n º B13538053 e inscrita en el Registro de CIUDAD REAL, Tomo 550, Libro 0, folio 206, hoja CR-21866 inscripción 1ª, es la titular de la página www.ydray.com</p>
    `,
  },

  send_files: {
    title: "Enviar archivos grandes hasta 10 GB gratis",
    description: `
      YDRAY es la manera más fácil y eficaz de enviar y transferir archivos grandes de forma rápida con la máxima
      privacidad y seguridad hasta 10 GB gratis
    `,
    content: `
      <h1>Enviar archivos con YDRAY</h1>
      <p>
        YDRAY es una herramienta <strong>versátil</strong> y <strong>práctica</strong> que puede brindarte
        múltiples beneficios tanto en <strong>tu trabajo</strong> como en <strong>tu vida personal</strong>.
        Con su capacidad para <a class="link" href="/es/enviar-archivos/grandes" title="Enviar archivos de grandes
        con YDRAY">enviar archivos de grandes</a> de manera rápida y sencilla, YDRAY se ha convertido en una
        solución <strong>fiable</strong> y <strong>segura</strong> para gestionar tus archivos digitales. A
        continuación, exploraremos cómo YDRAY puede ayudarte en ambos ámbitos.
      </p>
      <h2>YDRAY en el trabajo</h2>
      <img
        src="../../../assets/images/send-files-working.png"
        alt="Enviando archivos en el entorno laboral"
        title="Enviando archivos en el entorno laboral"
        height="auto"
        width="auto"
        loading="eager"
      />
      <p>
        YDRAY es una herramienta <strong>imprescindible</strong> para enviar y compartir archivos con
        compañeros, colaboradores y clientes. Puedes enviar fácilmente presentaciones, documentos,
        imágenes, videos y otros archivos relacionados con tu trabajo. Ya sea que necesites enviar un
        archivo a un compañeros en la misma o distinta oficina, colaboradores de otras ciudades o a un
        cliente en el extranjero, YDRAY te permite hacerlo de <strong>manera eficiente</strong>,
        <strong>rápida</strong> y <strong>sin complicaciones</strong>. Puedes enviar y compartir archivos
        de gran tamaño sin preocuparte por las limitaciones de tamaño de los correos electrónicos o los
        sistemas de mensajería tradicionales.
      </p>
      <p>
        Además con sus opciones a la hora de enviar archivos, YDRAY también te permite
        colaborar de manera efectiva en proyectos de equipo. Puedes enviar carpetas enteras
        con tus colaboradores, lo que facilita <strong>la colaboración</strong> y <strong>el intercambio de ideas</strong>.
        Los miembros del equipo pueden agregar y descargar archivos, mantenerse actualizados con las últimas
        versiones y trabajar de manera conjunta. Esta funcionalidad promueve <strong>la productividad</strong>
        y <strong>la eficiencia</strong> en el entorno laboral, ya que elimina la necesidad de enviar múltiples
        correos electrónicos o utilizar dispositivos de almacenamiento externo.
      </p>
      <h2>YDRAY en tu vida personal</h2>
      <img
        src="../../../assets/images/send-files-friends.png"
        title="Enviando archivos en el entorno personal"
        alt="Enviando archivos en el entorno personal"
        height="auto"
        width="auto"
        loading="lazy"
      />
      <p>
        YDRAY también es útil para enviar archivos a <strong>amigos</strong> y <strong>familiares</strong>.
        Puedes compartir fotos y videos de tus últimas vacaciones, celebraciones de boda o cumpleaños, así
        documentos importantes o cualquier otro archivo que desees enviar o compartir con tus seres
        queridos. YDRAY <strong>facilita</strong> la labor de enviar estos archivos, incluso si son de <strong>gran
        tamaño</strong>, lo que te permite mantener a tus seres queridos actualizados y compartir momentos
        significativos.
      </p>
      <p>
        YDRAY es una herramienta que te brinda <strong>tranquilidad</strong> en términos de <strong>privacidad</strong> y
        <strong>seguridad</strong>. Utiliza cifrado de extremo a extremo para proteger tus archivos durante la
        transferencia, lo que significa que solo tú y los destinatarios autorizados pueden acceder a ellos.
        Esto es especialmente importante cuando se trata de enviar archivos confidenciales o sensibles.
        Puedes tener la <strong>confianza</strong> de que tus archivos están protegidos y se comparten de manera segura
        a través de YDRAY. Además ofrece la posibilidad de enviar y compartir tus archivos asignando una
        contraseña al envío de los mismos, dando una capa extra de <strong>protección</strong>.
      </p>
      <h2>Consejos para enviar archivos</h2>
      <img
        src="../../../assets/images/send-files-doubts.png"
        title="Consejos para enviar archivos"
        alt="Consejos para enviar archivos"
        height="auto"
        width="auto"
        loading="lazy"
      />
      <h3>¿Cómo se pueden enviar los archivos?</h3>
      <p>
        Con YDRAY, puedes enviar archivos de <strong>manera sencilla</strong>. Solo visita ydray.com,
        selecciona los archivos que deseas compartir y <strong>genera un link</strong> para compartir
        por email, Facebook, Instagram, X (Twitter), Whatsapp o Gmail. Haz click en generar enlace e YDRAY
        se encargará de compartir tus archivos de forma segura y con la máxima privacidad. ¡Así de fácil!
      </p>
      <h3>¿Cuál es la mejor plataforma para compartir archivos?</h3>
      <p>
        La mejor plataforma para enviar y compartir archivos es Ydray.com. Con su interfaz
        <strong>intuitiva</strong> y <strong>fácil de usar</strong>, puedes enviar archivos de gran
        tamaño de manera rápida y segura. YDRAY te permite compartir archivos con amigos, compañeros
        de trabajo, amigos o clientes de forma sencilla, haciendo que la experiencia de
        compartir archivos sea eficiente y confiable.
        ¡Descubre YDRAY y disfruta de una forma práctica de enviar y compartir archivos en línea!
      </p>
      <h3>¿Dónde puedo enviar archivos pesados gratis?</h3>
      <p>
        YDRAY es la solución perfecta para <a class="link" href="/es/enviar-archivos/gratis"
        title="Enviar archivos gratis con YDRAY">enviar archivos gratis</a>. Con YDRAY, puedes enviar
        archivos de <strong>gran tamaño</strong> de manera fácil y rápida a cualquier persona en todo
        el mundo. Simplemente visita Ydray.com, selecciona los archivos que deseas enviar y genera el
        enlace para compartir tus archivos. ¡Comparte archivos sin límites y de forma gratuita con YDRAY!
      </p>
      <h3>¿Cómo se llama la página para enviar archivos?</h3>
      <p>
        La página popularmente conocida para enviar y compartir archivos se llama YDRAY. Con
        YDRAY, puedes enviar y compartir archivos fácilmente de forma <strong>segura</strong> y
        <strong>rápida</strong>. Simplemente visita ydray.com, selecciona los archivos que deseas
        enviar y compártelos con tus destinatarios. ¡Así podrás enviar y compartir archivos
        de manera eficiente con YDRAY!
      </p>
      <h2>En definitiva, YDRAY</h2>
      <p>
        YDRAY es una <strong>herramienta valiosa</strong> para enviar y compartir archivos tanto
        en el trabajo como en tu vida personal. <strong>Facilita</strong> la transferencia de archivos
        de gran tamaño, <strong>fomenta</strong> la colaboración en equipo y ofrece seguridad y
        privacidad en tus envíos. Ya sea para proyectos laborales o para compartir momentos especiales
        con tus seres queridos, YDRAY es una opción <strong>confiable</strong> y <strong>conveniente</strong>
        que simplificará tus tareas de envío y compartir archivos.
      </p>
    `,
  },

  send_files_big: {
    title: `Enviar archivos grandes`,
    description: `Enviar archivos grandes`,
    content: `
    <h1>Envía tus archivos grandes con YDRAY</h1>
    <h2>¿Necesitas enviar tus archivos grandes?</h2>
    <img
      src="../../../assets/images/send-big-files-doubts.png"
      alt="Enviar archivos grandes con YDRAY"
      title="Enviar archivos grandes con YDRAY"
      height="auto"
      width="auto"
      loading="eager"
    />
    <p>
      YDRAY es la plataforma más poderosa que te permite enviar archivos grandes y pesados,
      es decir de <strong>gran tamaño</strong>, de manera <strong>eficiente</strong> y <strong>segura</strong>.
      Sin embargo, YDRAY destaca de sus competidores, brindándote una experiencia superior a la hora de
      <strong>compartir archivos grandes</strong>.
    </p>
    <p>
      Una de las ventajas clave de YDRAY es su capacidad para
      <a class="link" href="/es/enviar-archivos" title="Enviar archivos con YDRAY">enviar archivos</a>
      de forma gratuita. A diferencia de muchos otros servicios, con YDRAY puedes <strong>enviar
      archivos grandes de hasta 10GB</strong> sin costes adicionales, es decir, totalmente <strong>gratis</strong>.
      Esto es especialmente interesante cuando necesitas <strong>enviar</strong> presentaciones, proyectos multimedia,
      diseños en 3D o archivos pesados que exceden los límites de tamaño de otros servicios. YDRAY te brinda la
      libertad de <strong>enviar archivos grandes y pesados</strong> sin restricciones de tamaño y sin gastar dinero extra.
    </p>
    <h2>Caraterísticas de YDRAY</h2>
    <img
      src="../../../assets/images/send-big-files-characteristics.png"
      alt="Características de YDRAY"
      title="Características de YDRAY"
      height="auto"
      width="auto"
      loading="eager"
    />
    <p>
      YDRAY sobresale en términos de <strong>seguridad</strong> y <strong>privacidad</strong>. Utilizando
      <strong>cifrado de extremo a extremo</strong> para todas las transferencias de archivos pesados,
      lo que garantiza que tus datos estén <strong>protegidos</strong> durante la transmisión. YDRAY se 
      compromete con la <strong>confidencialidad</strong> de tus archivos grandes y te brinda <strong>tranquilidad</strong>
      al saber que tus documentos y contenido multimedia estarán <strong>seguros</strong> y solo accesibles
      para los destinatarios autorizados. YDRAY es <strong>la mejor opción</strong> para enviar archivos pesados en
      cumplimiento con la <strong>GDPR (General Data Protection Regulation)</strong>.
    </p>
    <p>
      YDRAY tiene una <strong>interfaz intuitiva</strong> y <strong>fácil de usar</strong>.
      YDRAY sitúa al usuario en el centro de la proceso, cuenta con la mejor <strong>experiencia de usuario</strong>
      a la hora de <strong>transferir archivos</strong>. El proceso a la hora de enviar archivos grandes se simplifica
      al máximo, lo que te permite <strong>ahorrar tiempo</strong> y <strong>esfuerzo</strong>.
      Con solo unos pocos clics, puedes subir tus archivos pesados, seleccionar entre las múltiples opciones gratuitas y
      <strong>compartir el enlace de descarga</strong>, ya sea copiando el enlace, utilizando tu email, Gmail, Facebook,
      X (Twitter) e incluso por Whatsapp. La <strong>simplicidad</strong> y la <strong>eficiencia</strong> son
      elementos clave en la experiencia de usuario de YDRAY, lo que te permite enviar archivos grandes y
      pesados de manera rápida y sin complicaciones.
    </p>
    <p>
      YDRAY ofrece opciones de <strong>personalización</strong> para adaptarse a tus necesidades. Puedes agregar <strong>mensajes</strong>
      personalizados a tus envíos, <strong>título</strong> asociado al enlace de descarga y establecer <strong>fechas de caducidad</strong>
      para que los archivos estén disponibles solo por un tiempo limitado. Esta flexibilidad te permite tener un mayor control sobre tus
      transferencias y asegurarte de que los archivos se compartan según tus preferencias.
    </p>
    <h2>Conclusiones</h2>
    <img
      src="../../../assets/images/send-big-files-conclusions.png"
      alt="Conclusiones"
      title="Conclusiones"
      height="auto"
      width="auto"
      loading="eager"
    />
    <p>
      YDRAY se posiciona como una opción destacada para strong>enviar archivos <grandes</strong>, de <strong>gran tamaño</strong> y
      <strong>pesados</strong> de manera totalmente <strong>gratuita</strong>. Sus fortalezas en términos de <strong>capacidad de almacenamiento</strong>,
      <strong>seguridad</strong> y <strong>facilidad de uso</strong> la distinguen de otros competidores en el mercado de transferencia de archivos,
      ofreciéndote una solución <strong>confiable</strong> y <strong>conveniente</strong> para tus necesidades de envío y compartición de archivos.
      Prueba YDRAY y descubre una forma <strong>eficiente</strong> y <strong>segura</strong> de enviar y compartir archivos grandes y pesados,
      <strong>gratis</strong> y <strong>sin limitaciones</strong>.
    </p>
    `,
  },

  send_files_free: {
    title: `Enviar archivos gratis`,
    description: `Envia archivos gratis`,
    content: `
      <h1>Envía tus archivos gratis con YDRAY</h1>
      <h2>¿Necesitas enviar tus archivos de forma gratuita?</h2>
      <img
        src="../../../assets/images/send-free-files-doubts.png"
        alt="Enviar archivos gratis con YDRAY"
        title="Enviar archivos gratis con YDRAY"
        height="auto"
        width="auto"
        loading="eager"
      />
      <p>
        YDRAY es una excelente opción para satisfacer tus necesidades. YDRAY destaca, como plataforma de envío archivos gratis,
        por sus características únicas que la diferencia de sus competidores, permitiéndote enviar archivos gratis de manera eficiente
        y sin coste alguno, es decir, <strong>YDRAY te permite enviar tus archivos gratis</strong>.
      </p>
      <h2>Características de YDRAY</h2>
      <img
        src="../../../assets/images/send-free-files-characteristics.png"
        alt="Características de YDRAY"
        title="Características de YDRAY"
        height="auto"
        width="auto"
        loading="eager"
      />
      <p>
        YDRAY te brinda la posibilidad de <strong>enviar archivos gratis</strong>. Puedes transferir tus documentos, fotos, videos
        y demás archivos sin coste adicional. Esta opción es ideal para aquellos que necesitan enviar archivos de manera ocasional
        o que no requieren de funcionalidades avanzadas.
      </p>
      <p>
        YDRAY también te permite <strong>enviar archivos gratis de manera sencilla</strong>. Puedes compartir un enlace de descarga a tus contactos,
        que podrán acceder a los archivos de forma <strong>rápida</strong> y <strong>cómoda</strong>. Enviar archivos gratis se vuelve un proceso
        <strong>ágil</strong> y <strong>conveniente</strong>, ya que no es necesario que los destinatarios se registren en la plataforma para acceder
        a los archivos compartidos.
      </p>
      <h2>Ventajas de usar YDRAY</h2>
      <img
        src="../../../assets/images/send-free-files-cost.png"
        alt="Ventajas de usar YDRAY"
        title="Ventajas de usar YDRAY"
        height="auto"
        width="auto"
        loading="lazy"
      />
      <p>
        Una de las ventajas significativas de YDRAY es su capacidad para <strong>enviar archivos gratis</strong>. YDRAY te permite
        <strong>enviar archivos de gran tamaño</strong>, lo cual es especialmente útil cuando necesitas compartir presentaciones,
        videos en alta calidad o tus proyectos más creativos. Olvídate de los límites de tamaño y <strong>envía tus archivos gratis</strong>
        sin problemas.
      </p>
      <p>
        YDRAY te ofrece opciones <strong>gratuitas</strong> para <strong>compartir archivos grandes</strong>. No solo podrás
        <a class="link" href="/es/enviar-archivos" title="Enviar archivos con YDRAY">enviar archivos</a>, sino que también podrás
        <strong>enviarlos gratis</strong>. Esto es especialmente valioso para profesionales y empresas que necesitan <strong>enviar archivos</strong>
        de manera regular, sin incurrir en gastos innecesarios. Tienes opciones para configurar el <strong>envio de archivos totalmente
        gratuitas</strong>, tales como seleccionar una contraseña o la caducidad del enlace generado para compartir tus archivos.
      </p>
      <h2>Conclusiones</h2>
      <img
        src="../../../assets/images/send-free-files-end.png"
        alt="Conclusiones"
        title="Conclusiones"
        height="auto"
        width="auto"
        loading="lazy"
      />
      <p>
        YDRAY te brinda la posibilidad de <strong>enviar archivos de forma gratuita</strong>, enfocándose en la <strong>simplicidad</strong>
        y la <strong>eficiencia</strong>, con una experiencia de usuario totalmente revolucionaria e innovadora. YDRAY destaca en el <strong>envío seguro
        de archivos gratis</strong> y ofrece opciones gratuitas para compartir, por lo que la convierte en una excelente <strong>alternativa frente a sus
        competidores</strong>. Si necesitas <strong>enviar archivos</strong> de manera ágil y gratuita, no dudes en aprovechar las ventajas
        que te ofrece YDRAY. Envía, comparte y disfruta de una experiencia sin complicaciones con la <strong>plataforma líder en el mercado de
        transferencia de archivos</strong>.
      </p>
    `,
  },

  share_files: {
    title: "Compartir archivos grandes y pesados hasta 10 GB gratis",
    description: `
      YDRAY es la forma más rápida y fácil de transferir y compartir archivos grandes y pesados de forma segura con la máxima privacidad y seguridad hasta 10 GB gratis
    `,
    content: `
      <h1>Compartir archivos con YDRAY</h1>
      <p>
        Como empresa, la <strong>privacidad</strong> y <strong>seguridad</strong> de los archivos que compartes son de mucha
        importancia. YDRAY es una herramienta que puede ayudarte a <a class="link" href="/es/compartir-archivos/gratis"
        title="compartir archivos gratis con YDRAY">compartir archivos gratis</a> de manera privada,
        asegurando la <strong>confidencialidad</strong> de la información de tus clientes y garantizando el cumplimiento
        de las regulaciones de protección de datos.
      </p>
      <h2>Fácil de usar</h2>
      <img
        src="../../../assets/images/share-files-easy.png"
        alt="Facilidad al enviar archivos"
        title="Facilidad al enviar archivos"
        height="auto"
        width="auto"
        loading="eager"
      />
      <p>
        YDRAY es una herramienta fácil de usar. Su interfaz <strong>intuitiva</strong> te permite
        <a class="link" href="/es/compartir-archivos/grandes" title="Enviar archivos grandes con YDRAY">enviar archivos grandes</a>
        rápidamente con solo unos pocos clics. No requiere de conocimientos técnicos avanzados, lo que facilita su uso
        tanto para <strong>usos profesionales</strong> como para <strong>usos personales</strong>.
      </p>
      <h2>Privacidad en tus comunicaciones</h2>
      <img
        src="../../../assets/images/share-files-lock.png"
        alt="Seguridad al compartir archivos"
        title="Seguridad al compartir archivos"
        height="auto"
        width="auto"
        loading="lazy"
      />
      <p>
        YDRAY se compromete a mantener la privacidad de tus archivos. No almacena tus archivos
        en sus servidores más tiempo del necesario. Una vez que el archivo se ha transferido con éxito y
        ha pasado el plazo establecido en el envío, se <strong>elimina automáticamente</strong> de los servidores
        de YDRAY. Esto <strong>reduce el riesgo</strong> de exposición accidental o <strong>acceso no autorizado</strong> a
        los archivos compartidos.
      </p>
      <p>
        YDRAY ofrece un <strong>entorno seguro</strong> para el envío de archivos. Utiliza encriptación de
        extremo a extremo, lo que significa que los archivos se <strong>cifran</strong> antes de salir de tu
        dispositivo y solo se descifran una vez que llegan al dispositivo del destinatario. Esto garantiza que los
        archivos estén <strong>protegidos</strong> durante todo el proceso de transferencia y evita el acceso no autorizado
        a la información confidencial.
      </p>
      <p>
        YDRAY también te permite <strong>establecer contraseñas</strong> para los archivos que envías agregando
        una capa adicional de <strong>seguridad</strong>. Puedes asignar una contraseña única para cada archivo, lo que
        garantiza que solo los <strong>destinatarios autorizados</strong> puedan acceder a ellos. Esta función es
        especialmente útil cuando envías archivos con <strong>información sensible</strong>.
      </p>
      <h2>Personalización de tus envíos</h2>
      <img
        src="../../../assets/images/share-files-custom.png"
        alt="Personalización de tus archivos compartidos"
        title="Personalización de tus archivos compartidos"
        height="auto"
        width="auto"
        loading="lazy"
      />
      <p>
        Otra característica valiosa de YDRAY es la capacidad de <strong>personalizar tus transferencias</strong>. Puedes
        agregar tu logotipo al enlace de descarga como opción de pago con la cuenta Pro, lo que ayuda a
        reforzar la identidad de tu negocio y brinda una experiencia <strong>más profesional</strong> a los
        destinatarios. Esto puede ser útil cuando envías archivos a colaboradores externos o incluso a tus
        clientes dando una <strong>imagen más corporativa</strong>.
      </p>
      <p>
        YDRAY también ofrece la opción de configurar una <strong>fecha de caducidad</strong> para tus transferencias. Esto
        significa que los archivos compartidos solo estarán disponibles para su descarga durante un
        <strong>período específico de tiempo</strong>. Después de la fecha de caducidad, los archivos se eliminan
        automáticamente, lo que limita aún más la exposición y garantiza que los archivos confidenciales
        no queden almacenados indefinidamente.
      </p>
      <h2>Consejos para compartir archivos</h2>
      <img
        src="../../../assets/images/share-files-doubts.png"
        alt="Consejos para compartir archivos"
        title="Consejos para compartir archivos"
        height="auto"
        width="auto"
        loading="lazy"
      />
      <h3>¿Cómo se pueden compartir archivos?</h3>
      <p>
        YDRAY es una plataforma <strong>confiable</strong> y <strong>segura</strong> para enviar
        y compartir archivos. Con YDRAY, puedes enviar <strong>archivos grandes</strong> de manera
        rápida y sencilla. Simplemente visita Ydray.com, selecciona los archivos que deseas compartir
        y <strong>genera el enlace</strong> a compartir ya sea por correo electrónico, Facebook,
        Instagram, X (Twitter) o Gmail. YDRAY se encargará de enviar y compartir tus archivos de forma
        privada y segura. ¡Descubre una nueva forma de enviar y compartir archivos con YDRAY!
      </p>
      <h3>¿Cuál es la mejor plataforma para compartir archivos?</h3>
      <p>
        La mejor plataforma para compartir archivos es YDRAY. Con YDRAY, puedes enviar y
        compartir archivos de forma <strong>rápida</strong>, <strong>segura</strong> y <strong>confiable</strong>.
        Es una herramienta <strong>fácil de usar</strong> que te permite compartir archivos grandes
        sin preocuparte por límites de tamaño. Cuenta con la <strong>mayor seguridad</strong> de mercado
        y proporciona la máxima privacidad en tus envíos de archivos ¡Descubre la experiencia de
        enviar y compartir archivos de manera eficiente con YDRAY!
      </p>
      <h3>¿Cómo se pueden compartir archivos de manera segura?</h3>
      <p>
        Con YDRAY, puedes compartir archivos de manera <strong>segura</strong> y <strong>confiable</strong>.
        Ydray.com es una plataforma que te permite enviar y compartir archivos de forma <strong>protegida</strong>,
        utilizando encriptación de extremo a extremo para garantizar la <strong>seguridad de tus datos</strong>.
        Simplemente visita Ydray.com, selecciona los archivos que deseas, y <strong>genera el
        enlace</strong> a compartir. YDRAY se encargará de enviar y compartir tus archivos de manera
        <strong>segura</strong> y <strong>confiable</strong>, protegiendo la privacidad de tus datos durante
        el proceso. ¡Disfruta de una forma segura de enviar y compartir archivos con YDRAY!
      </p>
      <h3>¿Cómo puedes compartir un archivo o carpeta con otra persona?</h3>
      <p>
        Con YDRAY, puedes compartir archivos o carpetas con otras personas de <strong>manera rápida</strong> y
        <strong>sencilla</strong>. Simplemente visita Ydray.com, selecciona los archivos o carpeta con tus
        archivos que deseas compartir y haz clic en <strong>Generar enlace</strong>. Podras compartir tu
        enlace por correo electrónico, Facebook, Instagram, X (Twitter) o Gmail. YDRAY se encargará de
        enviar y compartir los archivos <strong>forma segura</strong>. ¡Compartir nunca fue tan fácil
        con YDRAY!
      </p>
      <h2>En definitiva, YDRAY</h2>
      <p>
        YDRAY es una solución <strong>eficaz</strong> y <strong>segura</strong> para enviar y compartir archivos
        <strong>confidenciales</strong> en el contexto de tu empresa. Su encriptación de extremo a extremo, la
        posibilidad de establecer contraseñas y la eliminación automática de archivos garantizan la
        <strong>privacidad</strong> y <strong>confidencialidad</strong> de la información de los clientes.
        Además, su facilidad de uso y personalización hacen de YDRAY una herramienta conveniente y
        confiable para enviar archivos de forma privada y segura en tu práctica laboral.
      </p>
    `,
  },

  share_files_big: {
    title: `Compartir archivos grandes`,
    description: `Compartir archivos grandes`,
    content: `
    <h1>Compartir archivos grandes con YDRAY</h1>
    <p>
      En el mundo digital actual, tanto en tu trabajo como a nivel personal, surge la
      necesidad de compartir archivos grandes manera <strong>rápida</strong> y <strong>segura</strong>,
      hecho que se ha vuelto cada vez más importante. Afortunadamente, plataformas
      como YDRAY han surgido para facilitar este proceso y satisfacer las demandas de los
      usuarios más exigentes.
    </p>
    <h2>Características de YDRAY</h2>
    <img
      src="../../../assets/images/share-big-files-doubts.png"
      alt="Consejos para compartir archivos grandes"
      title="Consejos para compartir archivos grandes"
      height="auto"
      width="auto"
      loading="lazy"
    />
    <p>
      YDRAY destaca entre sus competidores al ofrecer soluciones <strong>eficientes</strong>
      y <strong>confiables</strong> para
      <a class="link" href="/es/compartir-archivos" title="Compartir archivos con YDRAY">compartir archivos</a>.
      Una de las ventajas clave de YDRAY es su generoso <strong>límite de tamaño</strong> de archivo de hasta 10 GB,
      lo cual lo convierte en una opción ideal para aquellos que necesitan <strong>compartir archivos
      de gran tamaño de forma gratuita</strong>. Esta opción es única en el mercado. Por otro lado,
      el principal competidor de YDRAY permite enviar archivos de hasta 2 GB de forma gratuita, lo cual
      sigue siendo una capacidad generosa en comparación con otros servicios, pero
      <strong>hasta 5 veces menor comparada con YDRAY</strong>.
    </p>
    <p>
      YDRAY se posiciona como una plataforma para compartir y transferir archivos
      grandes con una interfaz muy <strong>fácil de usar</strong> que permite a los
      usuarios subir y compartir archivos de manera <strong>rápida</strong> y
      <strong>sencilla</strong>. Simplemente selecciona o arrastra los archivos que deseas compartir,
      elige entre las diferentes opciones gratuitas posibles, (tales como poner <strong>título al envío</strong>,
      introducir un <strong>mensaje</strong>, seleccionar la <strong>fecha de caducidad</strong> el enlace
      de descarga o poner una contraseña a tu envío de archivos) y haz clic en el botón de envío.
      En cuestión de segundos, el destinatario recibirá un enlace para descargar los archivos compartidos.
      Este proceso simplificado <strong>ahorra tiempo</strong> y <strong>esfuerzo</strong>,
      eliminando la necesidad de utilizar métodos más complejos y menos eficientes para enviar archivos
      grandes y pesados.
    </p>
    <p>
      Una característica distintiva de YDRAY es su enfoque en la <strong>privacidad</strong> y
      <strong>seguridad</strong> de los archivos compartidos. La plataforma utiliza un 
      <strong>cifrado de extremo a extremo</strong> para garantizar que tus archivos estén protegidos
      durante el proceso de envío y recepción.
      Además, YDRAY ofrece opciones avanzadas de configuración, como <strong>establecer una
      contraseña para los archivos compartidos</strong> o <strong>programar su fecha de expiración</strong>.
      Estas características brindan un mayor control y tranquilidad a los usuarios que desean
      compartir archivos de <strong>manera segura</strong>.
    </p>
    <p>
      YDRAY se posiciona como la <strong>plataforma líder</strong> a nivel de privacidad a la hora de compartir
      archivos pesados, siendo una opción solida a la hora de transferir archivos grandes y totalmente <strong>gratis</strong>.
    </p>
    <p>
      En cuanto a la velocidad de transferencia, YDRAY se esfuerza por proporcionar una
      experiencia <strong>rápida</strong> y <strong>eficiente</strong>. Su infraestructura optimizada permite
      una carga y descarga de archivos <strong>ágil</strong>, lo que garantiza una transferencia fluida de
      archivos de gran tamaño y pesados.
    </p>
    <h2>Conclusiones</h2>
    <img
      src="../../../assets/images/share-big-files-characteristics.png"
      alt="Conclusiones al compartir archivos grandes"
      title="Conclusiones al compartir archivos grandes"
      height="auto"
      width="auto"
      loading="lazy"
    />
    <p>
      En resumen YDRAY es la mejor alternativa a sus competidores para <strong>compartir
      archivos grandes</strong>. YDRAY destaca por su <strong>generoso límite de tamaño de archivo de hasta
      10 GB totalmente gratis</strong>, su enfoque en la <strong>privacidad</strong> y <strong>seguridad</strong>,
      así como por sus opciones avanzadas de configuración. Otras alternativas ofrecen una
      capacidad de hasta 2 GB de forma gratuita. YDRAY trabaja diariamente para adaptarse a
      las necesidades de los usuarios modernos y proporcionar soluciones <strong>eficientes</strong> y
      <strong>confiables</strong> para compartir archivos grandes, archivos pesados y archivos de
      gran tamaño. <strong>¡No esperes más y comienza a disfrutar de una experiencia fluida y segura
      para compartir tus archivos grandes con YDRAY!</strong>
    </p>
    `,
  },

  share_files_free: {
    title: `Compartir archivos gratis`,
    description: `Compartir archivos gratis`,
    content: `
    <h1>Compartir archivos gratis con YDRAY</h1>
    <p>
      YDRAY es una excelente opción para compartir archivos <strong>gratis</strong> y
      <strong>sin coste</strong>, es decir, YDRAY es una plataforma de transferencia de archivos totalmente
      <strong>gratuita</strong>. YDRAY se destaca con sus características únicas y puntos fuertes en comparación con
      sus competidores, ofreciendo una <strong>experiencia superior al usuario</strong> compartiendo archivos.
    </p>
    <img
      src="../../../assets/images/share-free-files-doubts.png"
      alt="Compartir archivos gratis"
      title="Compartir archivos gratis"
      height="auto"
      width="auto"
      loading="lazy"
    />
    <h2>Ventajas de usar YDRAY</h2>
    <p>
      Una de las principales ventajas de YDRAY es su capacidad para
      <a class="link" href="/es/compartir-archivos/" title="Compartir archivos con YDRAY">compartir archivos</a>
      <strong>sin restricciones</strong>. Mientras que algunos servicios limitan el tamaño de los archivos que
      puedes enviar, YDRAY te permite <strong>compartir archivos</strong> de hasta 10GB <strong>gratis</strong>.
      Esta característica es especialmente valiosa cuando necesitas transferir y compartir archivos multimedia de
      alta calidad, proyectos creativos o cualquier otro contenido pesado. Con YDRAY, no hay límites para
      <strong>compartir tus archivos gratis</strong>.
    </p>
    <p>
      Además de compartir archivos gratis, YDRAY destaca en términos de <strong>velocidad</strong> y
      <strong>rendimiento</strong>. La plataforma utiliza una infraestructura de carga optimizada,
      lo que se traduce en <strong>transferencias rápidas</strong> y <strong>eficientes</strong> de tus
      archivos. Puedes compartir archivos gratis en cuestión de minutos, lo que agiliza tus procesos de trabajo y
      te permite enviar contenido de manera <strong>más eficiente</strong>.
    </p>
    <p>
      YDRAY es líder en </strong>experiencia de usuario</strong> a la hora de compartir archivos
      totalmente gratis. La plataforma de envío de archivos sitúa al usuario en el
      centro del proceso de transferencia de archivos, otorgándole de una experiencia <strong>sencilla</strong>,
      <strong>intuitiva</strong> y <strong>fácil de usar</strong>.
    </p>
    <p>
      Otro punto fuerte es su enfoque en la <strong>privacidad</strong> y <strong>seguridad</strong>
      de tus archivos. Utiliza <strong>cifrado de extremo a extremo</strong> para todas las transferencias, garantizando que
      tus datos estén protegidos durante todo el proceso. Además, <strong>YDRAY no almacena tus
      archivos en sus servidores más tiempo del necesario</strong>, lo que minimiza los riesgos de
      exposición y asegura la <strong>confidencialidad de tus documentos</strong> y contenido multimedia.
      YDRAY es la alternativa líder para compartir archivos gratis en <strong>cumplimiento con la
      GDPR (General Data Protection Regulation)</strong>.
    </p>
    <p>
      En términos de facilidad de uso, YDRAY se destaca con su <strong>interfaz intuitiva</strong>,
      <strong>sencilla</strong> y <strong>amigable</strong>. El proceso de envío de archivos gratis
      es <strong>simple</strong>, incluso para aquellos que no son expertos en tecnología. Solo necesitas cargar
      tus archivos, seleccionar las opciones disponibles y compartir tus archivos gratis.
      No hay complicaciones ni pasos innecesarios, lo que te <strong>ahorra tiempo</strong> y
      <strong>esfuerzo</strong> en tus tareas diarias.
    </p>
    <p>
      Por último, YDRAY ofrece <strong>opciones de personalización</strong> en tus enlaces de descarga de
      archivos para adaptarse a tus necesidades. Puedes agregar <strong>mensajes personalizados</strong>
      a tus transferencias, establecer </strong>fechas de caducidad</strong> del enlace y controlar quién
      puede acceder a tus archivos compartidos mediante una </strong>contraseña</strong>.
      Estas características te brindan un mayor control sobre tus transferencias de archivos y te permiten
      personalizarlas según tus preferencias.
    </p>
    <img
      src="../../../assets/images/share-free-files-advantages.png"
      alt="Conclusiones al compartir archivos gratis"
      title="Conclusiones al compartir archivos gratis"
      height="auto"
      width="auto"
      loading="lazy"
    />
    <h2>Conclusiones</h2>
    <p>
      En resumen, YDRAY es la mejor alternativa entre sus competidores a la hora de <strong>compartir archivos gratis</strong>.
      YDRAY destaca con sus puntos fuertes en términos de <strong>diseño</strong>, <strong>experiencia de usuario</strong>,
      <strong>tamaño de archivo</strong>, <strong>velocidad</strong>, <strong>privacidad</strong> y
      <strong>facilidad de uso</strong>. Si necesitas compartir archivos gratis, YDRAY es la solución <strong>confiable</strong>
      y <strong>conveniente</strong>. <strong>¡Descubre con YDRAY una forma rápida, segura y personalizable de compartir tus
      archivos totalmente gratis!</strong>
    </p>
    `,
  },

  more_info: {
    title: "Más Información",
    description: "Información adicional de YDRAY",
    content: `
    <h1>Más Información</h1>
    <h2 id="data-protection">Protección de datos</h2>
    <p>De conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril, relativo a la protección de las Personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos (en adelante, RGPD) le informamos sobre ello.</p>
    <h2 id="responsible">Responsable</h2>
    <p>RECICLAONLINE S.L</p>
    <h2 id="porpouse">Finalidad</h2>
    <p>Registro, gestión y servicio de envío de archivos de gran capacidad a través de nuestra web a terceros.</p>
    <h2 id="legitimation">Legitimación</h2>
    <p>Consentimiento expreso del usuario a través de la selección de la casilla check de aceptación del registro donde verifica su consentimiento.</p>
    <h2 id="recipient">Destinatarios</h2>
    <p>No existe ninguna cesión de datos prevista, salvo obligación legal.</p>
    <h2 id="rights">Derechos</h2>
    <span>Podrá ejercitar los derechos de acceso, rectificación, supresión, oposición, portabilidad y retirada de consentimiento de sus datos personales en la dirección de correo electrónico <a class="link" href="mailto:privacidad@ydray.com" target="_blank" title="Enviar email a privacidad@ydray.com">privacidad@ydray.com</a></span>
    <h2 id="origin">Procedencia</h2>
    <p>El propio interesado</p>
    `,
  },
  fileRequestsPublic: {
    limits: {
      maxFiles: "Hasta {{n}} archivos",
      maxFileSize: "{{size}} por archivo",
      maxTotalSize: "{{size}} en total",
      groupAriaLabel: "Límites de esta solicitud",
    },
    result: {
      success: {
        title: "¡Archivos enviados!",
        subtitle: "Tu envío se ha recibido con éxito",
        body: "Gracias por compartir los archivos con el propietario de la solicitud.",
        newUpload: "Nuevo envío",
        bannerCta: "Ir a YDRAY",
        bannerCtaAriaLabel:
          "Ir a YDRAY — envía tus propios archivos grandes gratis",
        summaryNextStep1: "El envío ha sido notificado por email.",
        summaryNextStep2: "El solicitante puede descargarlos desde YDRAY.",
        summaryNextStep3: "Tu envío llega de forma segura y privada.",
        summaryAriaLabel: "Resumen de tu envío",
        summaryLabel: "Resumen de tu envío",
        summaryListAriaLabel: "Detalles del envío",
        summaryFilesLabel_one: "archivo enviado ({{size}})",
        summaryFilesLabel_other: "archivos enviados ({{size}})",
        promoAriaLabel: "Descubre YDRAY",
        promoLabel: "Envía archivos con YDRAY",
        promoFeature1: "Hasta 10 GB por envío",
        promoFeature2: "Disponibles durante 7 días",
        promoFeature3: "Sin registro ni tarjeta",
        promoFeature4: "Enlace listo en segundos",
        promoFeature5: "Amplía tu capacidad con YDRAY PRO",
        promoFeaturesAriaLabel: "Características de YDRAY",
      },
      closed: {
        title: "Solicitud cerrada",
        subtitle: "El propietario ha cerrado esta solicitud",
        body: "Este enlace ya no acepta nuevos archivos. Contacta con el propietario si necesitas enviar algo.",
      },
      expired: {
        title: "Solicitud caducada",
        subtitle: "La ventana de envío ya se ha cerrado",
        body: "Esta solicitud ha caducado. El propietario ya no acepta envíos.",
        bodyWithDate: "Esta solicitud caducó el {{date}}. El propietario ya no acepta envíos.",
      },
      expired_during_submit: {
        title: "Tus archivos no se han enviado",
        subtitle: "La solicitud caducó durante la subida",
        body: "Aunque la subida llegó al final, la ventana de envío se cerró antes de confirmar la entrega. Contacta con el propietario para solicitar un nuevo enlace.",
        filesAriaLabel: "Archivos que estaban en cola",
      },
      not_started: {
        title: "Solicitud aún no activa",
        subtitle: "Esta solicitud comenzará más tarde",
        body: "El propietario ha programado esta solicitud para empezar en una fecha futura. Vuelve más tarde para enviar tus archivos.",
      },
      full: {
        title: "Solicitud completa",
        subtitle: "Se ha alcanzado el límite de envíos",
        body: "Esta solicitud ya ha recibido el número máximo de envíos permitidos.",
      },
      error: {
        title: "Ha ocurrido un error",
        subtitle: "Algo ha salido mal",
        body: "No hemos podido cargar la solicitud. Verifica que el enlace sea correcto e inténtalo de nuevo.",
        bodySubmit: "No hemos podido entregar tus archivos. Inténtalo de nuevo.",
        bodySessionExpired: "Tu sesión ha expirado durante la subida. Vuelve a abrir el enlace para reanudar.",
        retry: "Reintentar",
        contactSupport: "Contactar con soporte",
      },
      files_mismatch: {
        title: "Hay que actualizar la lista de archivos",
        subtitle: "Lo que ves aquí no coincide con lo que tenemos en el servidor",
        body: "Vamos a recargarla para que veas el estado real de tu envío. Podrás borrar lo que sobre o añadir lo que falte antes de volver a enviar.",
        countdown_one: "Actualizando en {{count}} segundo…",
        countdown_other: "Actualizando en {{count}} segundos…",
        refreshNow: "Actualizar ahora",
      },
      goHome: "Ir a YDRAY",
    },
    upload: {
      dropHere: "Suelta los archivos aquí",
      submit: "Enviar archivos",
      submitLoading: "Enviando…",
      submitLiveStatus: {
        sending: "Enviando archivos al destinatario…",
      },
      sessionExpired: {
        newSubmission:
          "Tu sesión caducó y se ha iniciado una nueva. Vuelve a seleccionar los archivos que querías enviar.",
      },
      viewStatus: {
        idle: "Formulario listo para enviar archivos.",
        otp: "Se requiere verificar tu email para continuar.",
        result: {
          success: "Envío completado correctamente.",
          error: "Ha ocurrido un error.",
          closed: "Esta solicitud está cerrada.",
          expired: "Esta solicitud ha caducado.",
          expired_during_submit: "Tus archivos no se han enviado.",
          files_mismatch:
            "Los archivos no coinciden con el servidor. Vamos a actualizar la lista.",
          full: "Esta solicitud ha alcanzado su límite.",
          not_started: "Esta solicitud aún no está activa.",
        },
      },
      viewMore: "Ver más",
      resumedBanner_one: "Tienes {{count}} archivo pendiente de un envío anterior.",
      resumedBanner_other: "Tienes {{count}} archivos pendientes de un envío anterior.",
      errors: {
        tooManyFiles_one: "Máximo de archivos alcanzado ({{count}} archivo)",
        tooManyFiles_other: "Máximo de archivos alcanzado ({{count}} archivos)",
        fileTooLarge: "Máximo de tamaño alcanzado ({{size}})",
        fileTooSmall: "El archivo está vacío",
        folderNotAllowed: "No se pueden añadir carpetas",
        duplicateFile: "Ya existe un archivo con ese nombre en la lista",
        totalSizeTooLarge: "Superado el tamaño total envío",
        server: {
          blocked_file_types: "Archivo no permitido",
          duplicate_file: "Nombre de archivo duplicado",
          file_too_large: "Tamaño de archivo",
          too_many_files: "Número de archivos",
          total_size_too_large: "Tamaño total envío",
          /* Códigos del catálogo del ST server — espejo de Requestuploadhandler.php.
           * Usados por el hook useUploadingListListeners al detectar errores
           * mid-chunk o al finalizar el archivo. */
          max_file_size: "El archivo supera el tamaño máximo permitido.",
          min_file_size: "El archivo es demasiado pequeño.",
          post_max_size: "El archivo supera el límite del servidor.",
          max_number_of_files: "Se ha superado el número máximo de archivos.",
          max_total_size: "Se ha superado el tamaño total permitido.",
          chunk_out_of_order:
            "Hubo un error subiendo este archivo. Vuelve a seleccionarlo.",
          unauthenticated: "Tu sesión ha expirado.",
          invalid_token: "Tu sesión ha expirado.",
          generic: "No se pudo subir el archivo.",
        },
      },
      fileList: {
        empty: "Arrastra tus archivos aquí",
        emptySecondary: "o selecciónalos desde tu equipo",
        emptyCta: "Seleccionar archivos",
        dropActiveStatus:
          "Zona de carga activa. Suelta los archivos para subirlos.",
        addToListHint: "Suéltalos para añadir a la lista",
        addMore: "Añadir",
        addMoreAriaLabel: "Añadir más archivos a la lista",
        addMoreAtMaxTitle: "Has alcanzado el límite de {{max}} archivos",
      },
      fileItem: {
        /* G: aria-labels contextuales con nombre de archivo */
        remove: "Eliminar {{filename}}",
        retry: "Reintentar subida de {{filename}}",
        state: {
          /* I: estado esperando */
          queued: "Esperando",
          uploading: "Subiendo",
          finished: "Finalizado",
          error: "Error",
        },
      },
      /* C5 · `aria-valuetext` para la ProgressBar del FileItem — el SR lee
       * este texto en lugar del default numérico "45 de 100". */
      progressBar: {
        queued: "{{filename}}, en cola",
        uploading: "{{filename}}, subiendo, {{percent}}%",
        finished: "{{filename}}, subida completa",
        error: "{{filename}}, error de subida",
      },
      columnHeaders: {
        sender: "Datos del envío",
        files: "Archivos",
        /* Badge de consumo del col-header. 7 variantes según presencia
         * de límites (maxFiles / maxTotalSize) y de archivos válidos:
         *
         *   limitsEmpty*  → estado vacío, comunica los límites configurados.
         *   validCount*   → estado con archivos, muestra consumo (X/Y · Z/W).
         *
         * `maxFileSize` (por archivo) no aparece aquí — vive en el dropzone
         * vacío y en toasts cuando se viola. */
        limitsEmptyBoth: "Máx {{max}} · {{size}}",
        limitsEmptyFiles_one: "Máx {{count}} archivo",
        limitsEmptyFiles_other: "Máx {{count}} archivos",
        limitsEmptySize: "Máx {{size}}",
        validCountBoth: "{{count}}/{{max}} · {{size}}/{{maxSize}}",
        validCountFiles: "{{count}}/{{max}} · {{size}}",
        validCountSize_one: "{{count}} archivo · {{size}}/{{maxSize}}",
        validCountSize_other: "{{count}} archivos · {{size}}/{{maxSize}}",
        validCountNone_one: "{{count}} archivo · {{size}}",
        validCountNone_other: "{{count}} archivos · {{size}}",
        errorCount_one: "{{count}} error",
        errorCount_other: "{{count}} errores",
      },
    },
    sender: {
      name: {
        label: "Nombre",
        placeholder: "Tu nombre",
        required: "El nombre es obligatorio",
      },
      email: {
        label: "Email",
        placeholder: "nombre@ejemplo.com",
        required: "El email es obligatorio",
        invalid: "Email no válido",
        tooLong: "Email demasiado largo",
      },
      message: {
        label: "Mensaje",
        placeholder: "Añade un mensaje para el destinatario...",
      },
    },
    seo: {
      title: "Solicitud de archivos",
      description: "Sube los archivos solicitados de forma segura.",
      titleByReason: {
        success: "Archivos enviados · Solicitud de archivos · YDRAY",
        error: "Error · Solicitud de archivos · YDRAY",
        closed: "Solicitud cerrada · YDRAY",
        expired: "Solicitud caducada · YDRAY",
        expired_during_submit: "Envío no entregado · YDRAY",
        files_mismatch: "Actualizando lista de archivos · YDRAY",
        full: "Solicitud completa · YDRAY",
        not_started: "Solicitud no iniciada · YDRAY",
      },
    },
    loading: {
      label: "Cargando solicitud de archivos…",
    },
    langSwitch: {
      ariaLabel: "Cambiar idioma",
    },
    topbar: {
      poweredBy: "Powered by",
      companyLogoAlt: "Logo de la empresa que solicita los archivos",
    },
    instructions_dialog: {
      title: "Instrucciones",
      close: "Cerrar",
      ariaTriggerLabel: "Ver instrucciones completas",
    },
    otp: {
      email: {
        title: "Acceso restringido",
        subtitle: "Introduce tu email para recibir el código de acceso",
        label: "Email",
        placeholder: "nombre@ejemplo.com",
        submit: "Enviar código",
        success:
          "Hemos enviado un código a tu correo. Revisa tu bandeja de entrada y SPAM",
        suggestion_label: "¿Quisiste decir {{suggested}}?",
        suggestion_aria_long:
          "¿Quisiste decir {{suggested}} en lugar de {{current}}?",
        suggestion_apply: "Aplicar",
        suggestion_dismiss_aria: "Mantener email original",
        errors: {
          email_not_allowed:
            "Este email no está autorizado para esta solicitud",
          email_failed:
            "No se ha podido enviar el código. Por favor, inténtalo de nuevo",
          not_found: "La solicitud no existe o ya no está activa",
          submission_limit_reached:
            "Se ha alcanzado el límite de envíos para esta solicitud",
          invalid_email: "El email introducido no es válido",
          missing_params: "Faltan datos obligatorios. Inténtalo de nuevo",
          otp_failed:
            "No se ha podido generar el código. Por favor, inténtalo de nuevo",
          captcha_failed:
            "La verificación anti-bots ha fallado. Inténtalo de nuevo",
          too_many_attempts:
            "Demasiados intentos. Espera unos minutos antes de volver a probar",
          request_not_started: "Esta solicitud aún no está activa",
          request_expired: "Esta solicitud ha caducado",
        },
      },
      code: {
        title: "Introduce el código",
        subtitle:
          "Hemos enviado un código a <emailAddress>{{email}}</emailAddress>",
        info: "El código caduca en 60 minutos. Revisa también tu carpeta de spam.",
        label: "Código de verificación",
        submit: "Verificar",
        back: "← Cambiar email",
        resend_available: "Reenviar código",
        resend_wait: "Reenviar en {{seconds}}s",
        resend_success: "Hemos enviado un nuevo código",
        success: "Verificación completada correctamente",
        live: {
          code_sent:
            "Código enviado a {{email}}. Introduce el código de verificación.",
          verifying: "Verificando código…",
          code_resent: "Nuevo código enviado",
        },
        errors: {
          invalid_otp: "El código es incorrecto. Revísalo e inténtalo de nuevo",
          invalid_otp_with_remaining_one:
            "Código incorrecto. Te queda {{count}} intento.",
          invalid_otp_with_remaining_other:
            "Código incorrecto. Te quedan {{count}} intentos.",
          invalid_otp_no_attempts:
            "Este código ya no es válido o ha caducado. Solicita uno nuevo.",
          too_many_attempts:
            "Demasiados intentos. Espera unos minutos antes de volver a intentarlo.",
          not_found: "La solicitud no existe o ya no está activa",
          missing_params: "Faltan datos obligatorios. Inténtalo de nuevo",
          max_attempts: "Has superado el número máximo de intentos",
          captcha_failed:
            "La verificación anti-bots ha fallado. Inténtalo de nuevo",
          submission_limit_reached:
            "Se ha alcanzado el límite de envíos para esta solicitud",
          request_not_started: "Esta solicitud aún no está activa",
          request_expired: "Esta solicitud ha caducado",
        },
      },
    },
  },
};
